/**
 * CRM no novo desenho (lotes 2 a 5, ficha 2026-10-26 "crm-novo-desenho"): textos das páginas do CRM do clone do RD, no
 * namespace do módulo (`pipeline:crm.*` e `pipeline:casca.*`). Entram em `../i18n.ts`.
 */
export const cascaPt = {
  comercial: "Comercial",
  atividades: "Atividades",
  configuracoes: "Configurações do CRM",
  central: "Central de Arquivos",
  relatorios: "Relatórios",
};

export const crmPt = {
  atividades: {
    titulo: "Atividades",
    criar: "Criar tarefa",
    todasTarefas: "Todas as tarefas",
    nResponsaveis_one: "{{count}} responsável",
    nResponsaveis_other: "{{count}} responsáveis",
    responsaveis: "Responsáveis",
    minhas: "Só as minhas",
    buscarResponsavel: "Buscar responsável",
    qualquerPeriodo: "Qualquer período",
    periodo: "Período",
    periodos: {
      hoje: "Hoje",
      semana: "Esta semana",
      mes: "Este mês",
      "7": "Últimos 7 dias",
      "14": "Últimos 14 dias",
      "30": "Últimos 30 dias",
      "180": "Últimos 6 meses",
      personalizado: "Período personalizado",
    },
    de: "De",
    ate: "Até",
    todosTipos: "Todos os tipos de tarefas",
    nTipos_one: "{{count}} tipo de tarefa",
    nTipos_other: "{{count}} tipos de tarefas",
    situacao: "Situação",
    situacoes: {
      atrasadas: "Atrasadas",
      pendentes: "Pendentes",
      concluidas: "Concluídas",
      todas: "Todos os status",
    },
    limparFiltros: "Limpar filtros",
    resumoSemana: "Resumo das tarefas da semana",
    diasDaSemana: "Dias {{de}} a {{ate}}",
    funil: "Funil",
    todosFunis: "Todos os funis",
    criadas: "Criadas",
    concluidas: "Concluídas",
    abertasEmDia: "Abertas em dia",
    atrasadas: "Atrasadas",
    colunas: {
      tarefa: "Tarefas",
      status: "Status",
      dataHora: "Data e hora",
      responsaveis: "Responsáveis",
      negociacao: "Negociação",
      valor: "Valor total",
    },
    status: {
      atrasada: "Atrasada",
      hoje: "Para hoje",
      futura: "Agendada",
      concluida: "Concluída",
      cancelada: "Cancelada",
    },
    selecionar: "Selecionar {{nome}}",
    selecionarPagina: "Selecionar as tarefas da página",
    selecionados_one: "{{count}} selecionada",
    selecionados_other: "{{count}} selecionadas",
    limparSelecao: "Limpar seleção",
    selecionarTodos: "Selecionar todos os {{count}} itens deste filtro",
    selecionarTodosLimite:
      "Selecionar os primeiros {{limite}} de {{count}} itens deste filtro",
    acoesMassa: "Ações com as selecionadas",
    adiar: "Adiar tarefa",
    adiarModos: {
      hora1: "Em 1 hora",
      hora2: "Em 2 horas",
      amanha: "Para amanhã",
      dias2: "Em 2 dias",
      semana: "Para a próxima semana",
      mes: "Para o próximo mês",
    },
    exportar: "Exportar",
    transferir: "Transferir tarefa",
    atribuir: "Atribuir responsável",
    concluir: "Marcar como concluída",
    escolherResponsavel: "Escolha o responsável",
    confirmarLote_one: "Aplicar em {{count}} tarefa?",
    confirmarLote_other: "Aplicar em {{count}} tarefas?",
    confirmarTransferir: "{{nome}} passa a ser o único responsável.",
    confirmarAtribuir: "{{nome}} entra como mais um responsável.",
    resultado: "{{alterados}} alteradas; {{ignorados}} sem mudança",
    exportado: "Exportação pronta",
    arquivoCsv: "tarefas.csv",
    sobre: "Sobre a negociação",
    vazio: "Nenhuma tarefa encontrada.",
    reuniaoNaAgenda: "Reunião agendada na Agenda",
    editar: "Editar tarefa",
    verAta: "Ver a ata",
    ataArquivos: "Arquivos anexados",
    ataArquivosFora_one: "{{count}} arquivo não está mais na negociação.",
    ataArquivosFora_other: "{{count}} arquivos não estão mais na negociação.",
    ata: "Ata da tarefa",
    concluidaEm: "Concluída em {{data}}",
    abrirNegociacao: "Abrir a negociação",
    sobreNegociacao: "Sobre a negociação",
    editarTarefa: "Editar a tarefa {{titulo}}",
    filtrosLigados: "Filtros ligados",
    filtrosN: "Filtros ({{n}})",
    filtrosTitulo: "Filtros",
    aplicarFiltros: "Aplicar filtros",
    periodoAgendamento: "Período de agendamento",
    tirarFiltro: "Tirar o filtro {{filtro}}",
    verRelatorio: "Ver relatório completo",
    configurar: "Workflows do comercial",
  },
  form: {
    criarTitulo: "Criar tarefa",
    editarTitulo: "Editar tarefa",
    proximaTitulo: "Criar próxima tarefa",
    empresa: "Empresa da negociação",
    negociacao: "Negociação",
    selecionar: "Selecionar",
    criarNegociacao: "Criar negociação para esta tarefa",
    assunto: "Assunto da tarefa",
    descricao: "Descrição da tarefa",
    responsaveis: "Responsáveis",
    principal: "principal",
    tipo: "Tipo de tarefa",
    dataHora: "Data e horário",
    concluirAoCriar: "Marcar como concluída ao criar",
    dica: "Crie tarefas automaticamente: os workflows do comercial sugerem a próxima tarefa ao concluir uma.",
    conhecerWorkflows: "Conhecer os workflows do comercial",
    semResponsavel: "Escolha ao menos um responsável",
    obrigatorio: "Campo obrigatório",
    selecioneNegociacao: "Selecione a negociação",
    criada: "Tarefa criada",
    criadaComMeet: "Tarefa criada. O link do Google Meet aparece na reunião em instantes.",
    descricaoLonga: "A descrição da reunião vai até {{max}} caracteres.",
    atualizada: "Tarefa atualizada",
    cancelarTarefa: "Cancelar tarefa",
    confirmarCancelar: "Cancelar esta tarefa?",
    confirmarCancelarTexto:
      "Ela sai das pendentes e fica no histórico da negociação como cancelada.",
    cancelada: "Tarefa cancelada",
    excluir: "Excluir",
    excluida: "Tarefa excluída",
    confirmarExcluir: "Excluir tarefa",
    confirmarExcluirTexto: "A tarefa será excluída e sai das listas e do histórico de tarefas. Esta ação não pode ser desfeita.",
    adicionarResponsavel: "Adicionar responsável",
    removerResponsavel: "Remover {{nome}}",
    justificativa: "Justificativa",
    justificativaAjuda: "Fica no histórico da negociação (de 10 a 500 caracteres).",
    reabrirTitulo: "Reabrir tarefa",
    reabrir: "Reabrir",
    reaberta: "Tarefa reaberta",
    reabrirDica: "A tarefa cancelada volta a pendente quando você salvar. Altere o que for preciso.",
    data: "Data do agendamento",
    horario: "Horário da tarefa",
    reuniaoAgenda: "Reunião agendada na Agenda: o horário muda pela Agenda.",
    descricaoConvidados: "Os convidados recebem esta descrição.",
    agendarNaAgenda: "Agendar na Agenda e no Google",
    agendarNaAgendaAjuda:
      "Desmarque para só registrar a atividade (reunião já feita ou marcada por fora).",
    servico: "Serviço",
    recurso: "Recurso (agenda de quem atende)",
    escolhaHorario: "Escolha um horário livre.",
  },
  atalho: {
    titulo: "Tarefas e reuniões",
    verHoje: "Ver hoje",
    semana: "Semana",
    semanaAnterior: "Semana anterior",
    proximaSemana: "Próxima semana",
    todas: "Mostrar as tarefas e reuniões de todos",
    carregando: "Carregando...",
    vazioTitulo: "Nenhuma tarefa ou reunião pendente",
    vazioTexto: "Experimente selecionar outra data ou use o botão abaixo para ver todas as suas tarefas.",
    irTarefas: "Ir para página de tarefas",
    abrirReuniao: "Abrir a reunião na Agenda",
    semTarefa: "Ver negociações sem tarefa",
  },
  semNegociacao: {
    titulo: "Esta tarefa precisa de uma negociação",
    texto:
      "Toda tarefa fica ligada a uma negociação. Você pode escolher uma que já existe ou criar a negociação agora.",
    guardado:
      "O que você já digitou na tarefa fica guardado e volta preenchido.",
    escolher: "Escolher uma existente",
    criar: "Criar negociação",
  },
  negociacaoTarefa: {
    titulo: "Criar negociação para a tarefa",
    aviso:
      "A tarefa que você estava criando ficou guardada. Ao criar a negociação, ela volta preenchida e já ligada a ela.",
    criarVoltar: "Criar e voltar para a tarefa",
    voltar: "Voltar para a tarefa",
  },
  concluir: {
    titulo: "Concluir tarefa",
    tituloVarias_one: "Concluir {{count}} tarefa",
    tituloVarias_other: "Concluir {{count}} tarefas",
    intro:
      "Para concluir, registre a ata ou o resumo do que foi feito. Use um exemplo ou insira o que o CRM já sabe da negociação; anexos são opcionais. Tudo vai para o histórico da negociação.",
    mesmaAta: "A mesma ata e os mesmos arquivos valem para todas.",
    exemplos: "Exemplos de ata",
    ata: "Ata / resumo do que foi feito",
    ataAjuda:
      "Clique num exemplo para começar; os trechos [ ] são para você completar (Tab pula para o próximo).",
    ataPlaceholder:
      "O que foi conversado, decidido e o próximo passo combinado",
    inserir: "Inserir do sistema",
    inserirAjuda: "(entra onde está o cursor)",
    arquivos: "Arquivos",
    opcional: "(opcional)",
    naNegociacao: "Documentos que já estão na negociação",
    grupoArquivos: "Arquivos da negociação",
    anexarNovo: "Anexar novo arquivo",
    removerArquivo: "Remover {{nome}}",
    botao: "Concluir tarefa",
    botaoVarias: "Concluir tarefas",
    concluida: "Tarefa concluída com a ata",
    concluidas: "Tarefas concluídas com a ata",
    erroCurta: "Escreva a ata ou o resumo (no mínimo 10 caracteres)",
    erroLacuna:
      "Complete os trechos [ ] do exemplo (ou apague os que não se aplicam)",
  },
  inserir: {
    negociacao: "Negociação",
    empresa: "Empresa",
    contato: "Contato",
    produtos: "Produtos",
    ultimaAnotacao: "Última anotação",
    ataAnterior: "Ata anterior",
    proximaReuniao: "Próxima reunião",
    negociacaoTxt: "Negociação {{nome}} · etapa {{etapa}} · valor {{valor}}",
    empresaTxt: "Empresa: {{nome}}",
    contatoTxt: "Contato: {{nome}}{{extra}}",
    produtosTxt: "Produtos: {{lista}}",
    anotacaoTxt: "Anotação de {{data}}: {{texto}}",
    ataAnteriorTxt: 'Na tarefa anterior ("{{titulo}}"): {{ata}}',
    reuniaoTxt: 'Próxima reunião: "{{titulo}}" em {{data}}',
    ultimaProposta: "Última proposta",
    ultimoEmail: "Último e-mail",
    propostaTxt: "Proposta #{{numero}} ({{estado}}) de {{data}} · valor {{valor}}{{para}}",
    enviadaPara: " · enviada para {{email}}",
    emailTxt: 'E-mail de {{data}}{{para}}: "{{assunto}}" · {{texto}}',
    paraEmail: " para {{email}}",
  },
  ata: {
    ocliente: "o cliente",
    aempresa: "a empresa",
    noTelefone: " no {{fone}}",
    hojeEm: " (hoje em {{etapa}})",
    modeloDe: "Modelo de {{tipo}}",
    modelos: {
      tarefa:
        'Tarefa "{{titulo}}" concluída. Resultado: [ ]. Próximo passo: [ ].',
      ligacao:
        'Liguei para {{quem}} ({{emp}}){{fone}}. Conversamos sobre "{{titulo}}". Ficou combinado: [ ]. Próximo passo: [ ].',
      reuniao:
        "Reunião com {{quem}} da {{emp}} em {{data}}. Pauta: {{titulo}}. Decisões: [ ]. Pendências do cliente: [ ]. Próximo passo: [ ].",
      email:
        'E-mail enviado para {{quem}}{{mail}} sobre "{{titulo}}". Aguardando resposta até [ ].',
      whatsapp:
        'Mensagem enviada a {{quem}} pelo WhatsApp{{fone}} sobre "{{titulo}}". Resposta do cliente: [ ].',
      visita:
        "Visita à {{emp}}, recebido por {{quem}}. O que vimos: [ ]. Combinado: [ ]. Próximo passo: [ ].",
      almoco: "Almoço com {{quem}} ({{emp}}). Assuntos: [ ]. Combinado: [ ].",
    },
    situacoes: {
      avancou: "Avançou",
      semRetorno: "Sem retorno",
      pediuProposta: "Pediu proposta",
      feito: "Feito como combinado",
    },
    textos: {
      avancou:
        "{{quem}} aprovou o próximo passo: [ ]. A negociação{{etapa}} segue para [ ].",
      semRetorno:
        "Tentei contato com {{quem}} e não tive retorno. Nova tentativa em [ ].",
      pediuProposta: "{{quem}} pediu a proposta com [ ]. Enviar até [ ].",
      feito: "Tarefa concluída como combinado. Resultado: [ ].",
      semRetornoMassa:
        "Tentei contato e não tive retorno. Nova tentativa em [ ].",
    },
  },
  proxima: {
    anteriores: "Resumo das tarefas anteriores",
    semAnteriores: "Nenhuma tarefa concluída antes nesta negociação.",
    sugestoes: "Sugestões de próxima tarefa",
    sugestoesAjuda:
      "Pelos workflows do comercial e pelo que foi escrito na ata. Clique para usar; dá para editar tudo abaixo.",
    emDias_one: "em {{count}} dia",
    emDias_other: "em {{count}} dias",
    motivoWorkflow: 'Workflow "{{nome}}", passo {{passo}}',
    motivoAta: "Pelo resumo: fala de {{palavra}}",
    motivoPadrao: "Sugestão padrão",
    configurar: "Configurar workflows",
    descricaoPadrao: 'Próximo passo depois de "{{titulo}}".',
  },
  pistas: {
    proposta: "Enviar proposta comercial",
    contrato: "Enviar contrato para assinatura",
    reuniao: "Reunião de apresentação",
    documentos: "Cobrar documentos pendentes",
    retorno: "Ligação de retorno",
    whatsapp: "Mensagem de acompanhamento",
    padrao: "Follow-up",
    palavra: {
      proposta: "proposta",
      contrato: "contrato",
      reuniao: "reunião",
      documentos: "documentos",
      retorno: "retorno",
      whatsapp: "WhatsApp",
    },
  },
  workflows: {
    titulo: "Workflows do comercial",
    intro1:
      'Crie quantos workflows precisar, cada um com o seu processo (venda consultiva, renovação, pós-venda...). Cada workflow tem passos: quando alguém concluir uma tarefa, o CRM abre "Criar próxima tarefa" com o resumo das tarefas anteriores e as sugestões dos workflows ligados.',
    intro2:
      "As sugestões também vêm do que foi escrito na ata (por exemplo, se a ata fala de proposta, sugere enviar a proposta).",
    abrirProxima: 'Abrir "Criar próxima tarefa" ao concluir uma tarefa',
    n_one: "{{count}} workflow",
    n_other: "{{count}} workflows",
    criar: "Criar workflow",
    editar: "Editar",
    duplicar: "Duplicar",
    excluir: "Excluir",
    confirmarExcluir: 'Excluir "{{nome}}"?',
    confirmarExcluirTexto_one:
      "O workflow e o passo dele saem. As tarefas já criadas não mudam.",
    confirmarExcluirTexto_other:
      "O workflow e os {{count}} passos dele saem. As tarefas já criadas não mudam.",
    vazio: "Nenhum workflow. As sugestões vêm só da ata até você criar um.",
    usarExemplos: "Criar os exemplos",
    todosFunis: "Todos os funis",
    passos_one: "{{count}} passo",
    passos_other: "{{count}} passos",
    desligadoSelo: "desligado",
    ligar: "Ligar o workflow {{nome}}",
    ligado: "Workflow ligado",
    desligado: "Workflow desligado",
    criado: "Workflow criado",
    atualizado: "Workflow atualizado",
    duplicado: "Workflow duplicado",
    excluido: "Workflow excluído",
    salvo: "Configuração salva",
    copia: "{{nome}} (cópia)",
    nome: "Nome do workflow",
    nomePlaceholder: "Ex.: Venda consultiva, Renovação, Pós-venda",
    valePara: "Vale para",
    passos: "Passos",
    passo: "Passo {{n}}",
    removerPasso: "Remover o passo {{n}}",
    quando: "Quando concluir",
    qualquer: "Qualquer tarefa",
    etapa: "Na etapa",
    qualquerEtapa: "Qualquer etapa",
    sugerir: "Sugerir",
    assunto: "Assunto",
    assuntoPlaceholder: "Ex.: Enviar proposta comercial",
    dias: "Em (dias)",
    adicionarPasso: "Adicionar passo",
    passoSemAssunto: "Passo {{n}}: informe o assunto da tarefa sugerida",
    previa:
      "Quando concluir {{quando}}{{etapa}} → sugerir {{tipo}} · {{assunto}} {{dias}}",
    previaQualquer: "qualquer tarefa",
    previaEtapa: " na etapa {{etapa}}",
    exemplos: {
      vendaConsultiva: "Venda consultiva",
      posVenda: "Pós-venda e relacionamento",
      diagnostico: "Reunião de diagnóstico",
      proposta: "Enviar proposta comercial",
      acompanhamento: "Ligação de acompanhamento da proposta",
      agradecer: "Agradecer a visita",
      resumo: "Enviar o resumo do que foi combinado",
    },
  },
  configuracoes: {
    titulo: "Configurações do CRM",
    secoes: {
      funis: "Funis de vendas",
      campos: "Configurar campos",
      motivos: "Motivo de perda",
      fontes: "Fontes e campanhas",
      qualificacao: "Qualificação",
      questionarios: "Questionários",
      modelos: "Modelos de proposta",
      workflows: "Workflows do comercial",
      "status-proposta": "Status de proposta",
    },
    salvo: "Configuração salva",
    salvar: "Salvar",
    statusProposta: {
      intro: "Os status que aparecem no menu de cada proposta. Cada status segue um estado base (criada, enviada, aceita ou recusada), que é o que as regras do CRM usam.",
      criar: "Criar status",
      editar: "Editar status",
      nome: "Nome do status",
      cor: "Cor",
      estadoBase: "Estado base",
      estadoBaseAjuda: "As regras do CRM leem o estado base: o envio da proposta, por exemplo, leva a criada para o status de \"enviada\".",
      estadoBaseTravado: "O estado base dos status de fábrica e dos status em uso não muda.",
      ativo: "Ativo",
      inativo: "Inativo",
      fabrica: "De fábrica",
      emUso_one: "{{count}} proposta",
      emUso_other: "{{count}} propostas",
      subir: "Subir {{nome}}",
      descer: "Descer {{nome}}",
      ativar: "Ativar {{nome}}",
      desativar: "Desativar {{nome}}",
      editarNome: "Editar {{nome}}",
      emUsoAviso: "Para desativar, mude antes as propostas deste status para outro.",
      cores: { neutro: "Cinza", acento: "Verde Malgo", roxo: "Roxo", azul: "Azul", ciano: "Ciano", laranja: "Laranja", dourado: "Amarelo", verde: "Verde", perigo: "Vermelho" },
    },
    funis: {
      intro: "Os funis e as etapas por onde passam as negociações. Em cada etapa aberta, o playbook diz o objetivo e os itens a conferir.",
      gerir: "Criar e organizar funis",
      adicionarEtapa: "Adicionar etapa",
      probabilidade: "{{n}}% de chance",
      comPlaybook: "Com playbook",
      configurarEtapa: "Configurar etapa",
      excluirEtapa: "Excluir a etapa {{nome}}",
      subirEtapa: "Levar a etapa {{nome}} para antes",
      descerEtapa: "Levar a etapa {{nome}} para depois",
      confirmarExcluir: "Excluir a etapa {{nome}}?",
      confirmarExcluirTexto: "Só dá para excluir uma etapa sem negociações. O funil precisa manter uma etapa aberta, uma de ganho e uma de perda.",
      probabilidadeInvalida: "Use um número inteiro de 0 a 100",
      nomeEtapa: "Nome da etapa",
      itensPlaybook: "Itens para conferir",
      itemN: "Item {{n}}",
      removerItem: "Remover o item {{n}}",
      adicionarItem: "Adicionar item",
    },
    campos: {
      intro: "Os campos personalizados das negociações ficam na tela de campos do sistema, junto com os dos outros módulos.",
      abrir: "Abrir os campos personalizados",
      ajuda: "Escolha a entidade Oportunidade para ver e criar os campos do comercial.",
    },
    fontes: {
      ajuda: "As fontes e campanhas aparecem como opções na ficha da negociação e nos filtros do Comercial.",
      fontes: "Fontes",
      campanhas: "Campanhas",
      livres: {
        fontes: "Permitir digitar uma fonte fora da lista",
        campanhas: "Permitir digitar uma campanha fora da lista",
      },
      vazio: "Nenhum item cadastrado.",
      excluir: "Excluir {{nome}}",
      nome: {
        fontes: "Nova fonte",
        campanhas: "Nova campanha",
      },
      descricao: "Descrição",
      adicionar: "Adicionar",
    },
    qualificacao: {
      semNome: "Dê um nome a cada nível",
      intro: "A qualificação vai de 1 a 5 estrelas. Dê um nome a cada nível; ele aparece ao passar o mouse nas estrelas.",
      nivel: "Nome do nível {{n}}",
      ajuda: "As negociações já qualificadas mantêm o número de estrelas; só o nome muda.",
    },
    questionarios: {
      intro: "Perguntas que o vendedor responde na ficha da negociação, na aba Questionários.",
      criar: "Criar questionário",
      editar: "Editar questionário",
      vazio: "Nenhum questionário ainda.",
      ligar: "Usar o questionário {{nome}}",
      perguntas_one: "{{count}} pergunta",
      perguntas_other: "{{count}} perguntas",
      confirmarExcluir: "Excluir o questionário {{nome}}?",
      confirmarExcluirTexto: "As respostas já dadas nas negociações deixam de aparecer.",
      semOpcoes: "Informe ao menos uma opção",
      nome: "Nome do questionário",
      pergunta: "Pergunta {{n}}",
      removerPergunta: "Remover a pergunta {{n}}",
      texto: "Pergunta",
      tipo: "Tipo de resposta",
      tipos: {
        texto: "Texto",
        sim_nao: "Sim ou não",
        opcoes: "Lista de opções",
        numero: "Número",
      },
      obrigatoria: "Resposta obrigatória",
      opcoes: "Opções",
      opcoesAjuda: "Uma opção por linha.",
      adicionarPergunta: "Adicionar pergunta",
    },
    modelos: {
      intro: "Os modelos dão a cor e os textos de partida das propostas. O modelo padrão já vem escolhido ao criar uma proposta.",
      criar: "Criar modelo",
      editar: "Editar modelo",
      rascunho: "Rascunho",
      tornarPadrao: "Tornar padrão",
      confirmarExcluir: "Excluir o modelo {{nome}}?",
      confirmarExcluirTexto: "As propostas já criadas com ele continuam como estão.",
      nome: "Nome do modelo",
      cor: "Cor",
      publicado: "Disponível para os vendedores",
    },
    semPermissao: "Só quem edita o comercial muda estas configurações.",
  },
  comercial: {
    titulo: "Pipeline",
    subtitulo: "Suas vendas em andamento, etapa por etapa",
    visao: "Visão",
    visoes: {
      funil: "Funil",
      lista: "Lista",
    },
    estatisticasEtapas: "Estatísticas das etapas",
    // Ajustes 27/10 (K4, K5, K8, K13, K14, K17, K18).
    sobre: "Sobre a negociação",
    sobreDe: "Sobre a negociação {{nome}}",
    recarregar: "Recarregar",
    recarregado: "Recarregado",
    recarregarEtapa: "Recarregar etapa",
    recarregarEtapaDe: "Recarregar a etapa {{etapa}}",
    etapaRecarregada: "Etapa recarregada",
    configurarFunil: "Configurar funil",
    avanco: "Avanço no pipeline",
    avancoAjuda: "Posição desta etapa entre as etapas abertas do funil: quanto do caminho a negociação já percorreu ao chegar aqui",
    adicionarValor: "Adicionar valor",
    maisOpcoes: "Mais opções",
    configurarFunis: "Configurar funis",
    personalizarCartoes: "Personalizar cartões",
    criar: "Criar",
    criarNegociacao: "Criar negociação",
    todasNegociacoes: "Todas as negociações",
    minhasNegociacoes: "Minhas negociações",
    etapa: "Etapa do funil",
    todasEtapas: "Todas as etapas",
    status: "Status da negociação",
    statusFiltro: {
      todos: "Todos os status",
      andamento: "Em andamento",
      vendido: "Vendido",
      perdido: "Perdido",
      pausado: "Pausado",
      nao_pausado: "Não pausado",
    },
    ordenacao: "Ordenação",
    ordens: {
      az: "Alfabética A-Z",
      za: "Alfabética Z-A",
      criadas_ultimo: "Criadas por último",
      criadas_primeiro: "Criadas primeiro",
      proxima_tarefa: "Data da próxima tarefa",
      previsao: "Previsão de fechamento",
      contato_recente: "Contato mais recente",
      contato_antigo: "Contato mais antigo",
      mais_qualificadas: "Mais qualificadas",
      menos_qualificadas: "Menos qualificadas",
      maior_valor: "Maior valor total",
      menor_valor: "Menor valor total",
      interacao_recente: "Interação mais recente",
      interacao_antiga: "Interação mais antiga",
    },
    filtrosN: "Filtros ({{n}})",
    filtrosLigados: "Filtros ligados",
    nNegociacoes_one: "{{count}} negociação",
    nNegociacoes_other: "{{count}} negociações",
    tirarFiltro: "Tirar o filtro {{filtro}}",
    estatisticaEtiqueta: "Estatística da etapa: {{nome}}",
    moverSoAbertas: "Para vender ou perder, use as ações da negociação",
    cartoesSalvos: "Cartões atualizados",
    cartoesAjuda:
      "Escolha os campos que aparecem no cartão da negociação no funil. Vale para todo o workspace.",
    camposCartao: {
      empresa: "Empresa / contato",
      qualificacao: "Qualificação",
      responsavel: "Responsável",
      valor: "Valor total",
      proxima_tarefa: "Próxima tarefa",
      criada_em: "Data de criação",
      fonte: "Fonte",
      previsao: "Previsão de fechamento",
      vertical: "Vertical",
      regime: "Regime tributário pretendido",
    },
    statusNeg: {
      andamento: "Em andamento",
      vendido: "Vendida",
      perdido: "Perdida",
      pausado: "Pausada",
    },
    semTarefas: "Sem tarefas",
    criadaEm: "Criada em {{data}}",
    fonteCartao: "Fonte: {{fonte}}",
    previsaoCartao: "Previsão: {{data}}",
    regimeCartao: "Regime: {{regime}}",
    estrelas_one: "{{count}} estrela",
    estrelas_other: "{{count}} estrelas",
    qualificacao: "Qualificação",
    estatisticas: {
      andamento: "Em andamento",
      sem_tarefa: "Sem tarefas",
      atrasadas: "Com tarefas atrasadas",
      sem_produtos: "Sem produtos ou serviços",
    },
    mostrarEstatisticas: "Mostrar as estatísticas de {{etapa}}",
    esconderEstatisticas: "Esconder as estatísticas de {{etapa}}",
    conversao: "Conversão da etapa",
    conversaoAjuda:
      "Das {{entraram}} negociações do funil que chegaram a esta etapa, {{avancaram}} avançaram para uma etapa seguinte ou foram vendidas",
    conversaoDe: "({{avancaram}} de {{entraram}})",
    mostrandoDe:
      "Mostrando {{n}} de {{total}}: use os filtros ou a lista para ver o resto",
    resultado: "{{alterados}} alteradas; {{ignorados}} sem mudança",
    exportCab: [
      "Nome",
      "Empresa",
      "Etapa",
      "Status",
      "Responsável",
      "Qualificação",
      "Fonte",
      "Campanha",
      "Valor único",
      "Valor recorrente",
      "Criada em",
      "Previsão",
    ],
    arquivoCsv: "negociacoes.csv",
    exportadas_one: "{{count}} negociação exportada",
    exportadas_other: "{{count}} negociações exportadas",
    selecionadas_one: "{{count}} selecionada",
    selecionadas_other: "{{count}} selecionadas",
    selecionarPagina: "Selecionar as negociações da página",
    colunas: {
      negociacao: "Negociações",
      responsavel: "Responsável",
      qualificacao: "Qualificação",
      etapa: "Etapa do funil",
      valor: "Valor total",
      criacao: "Data de criação",
      status: "Status",
    },
    unico: "Único: {{valor}}",
    recorrente: "Recorrente: {{valor}}",
    vazio: "Nenhuma negociação encontrada.",
    exibindo: "Exibindo",
    porPagina: "Negociações por página",
    deTotal: "de {{total}}",
    anterior: "Anterior",
    proxima: "Próxima",
    lote: {
      transferir: "Transferir",
      status: "Alterar status",
      campo: "Adicionar ou alterar",
      tarefa: "Criar tarefa",
      mover: "Mover",
      excluir: "Excluir",
      transferirTitulo: "Deseja transferir as negociações?",
      transferirTexto: "Você está transferindo {{n}} para {{nome}}.",
      perguntaTransferir: "Quantas negociações serão transferidas?",
      transferirBotao: "Transferir negociações",
      statusTitulo: "Deseja alterar o status das negociações?",
      statusTexto: "Você está alterando o status de {{n}} para {{status}}.",
      perguntaAlterar: "Quantas negociações serão alteradas?",
      statusBotao: "Alterar status",
      campoTitulo: "Adicionar ou alterar {{campo}}",
      campoTexto: "Você está alterando {{campo}} de {{n}}.",
      campoBotao: "Adicionar ou alterar",
      produtoTexto: "Você está adicionando um produto ou serviço a {{n}}.",
      tarefaTitulo: "Criar tarefa para as negociações selecionadas",
      tarefaTexto:
        "Uma tarefa em cada uma das {{n}}, com o responsável de cada negociação.",
      perguntaCriar: "Para quantas negociações?",
      tarefaBotao: "Criar tarefas",
      moverTitulo: "Mover negociações",
      moverTexto: "Você está movendo {{n}} para outra etapa do funil.",
      moverBotao: "Mover negociações",
      excluirTitulo: "Excluir negociações",
      excluirTexto:
        "Você está excluindo {{n}}, com as tarefas delas. Elas ficam 30 dias na lixeira.",
      perguntaExcluir: "Quantas negociações serão excluídas?",
      excluirBotao: "Excluir negociações",
    },
  },
  // Ajustes 27/10 (K18): "Sobre a negociação".
  sobre: {
    etapa: "Etapa",
    hoje: "Entrou hoje",
    haDias_one: "Há {{count}} dia nesta etapa",
    haDias_other: "Há {{count}} dias nesta etapa",
    funil: "Funil",
    responsavel: "Responsável",
    semResponsavel: "Sem responsável",
    empresa: "Empresa",
    contatoPrincipal: "Contato principal",
    semContato: "Sem contato",
    vertical: "Vertical",
    produtos: "Produtos",
    semProdutos: "Nenhum produto",
    maisN: "+{{count}}",
    origem: "Origem",
    atividades: "Atividades",
    nPendentes_one: "{{count}} pendente",
    nPendentes_other: "{{count}} pendentes",
    nAtrasadas_one: "{{count}} atrasada",
    nAtrasadas_other: "{{count}} atrasadas",
    ultimaAtividade: "Última: {{tipo}} · {{titulo}} em {{quando}}",
    semUltimaAtividade: "Nenhuma atividade concluída",
    questionarios: "Questionários",
    nEmAndamento_one: "{{count}} em andamento",
    nEmAndamento_other: "{{count}} em andamento",
    nConcluidos_one: "{{count}} concluído",
    nConcluidos_other: "{{count}} concluídos",
    semQuestionarios: "Nenhum questionário",
    propostas: "Propostas",
    propostaN: "Proposta nº {{n}}",
    semPropostas: "Nenhuma proposta",
    camposPersonalizados: "Campos personalizados",
    dadosGerais: "Dados gerais",
    fonte: "Fonte",
    campanha: "Campanha",
    interacoes: "Interações",
    nInteracoes_one: "{{count}} interação",
    nInteracoes_other: "{{count}} interações",
    ultimaAnotacao: "Última anotação",
    semAnotacao: "Nenhuma anotação foi feita para essa negociação",
    criacao: "Data de criação",
    ultimoContato: "Último contato",
    previsao: "Previsão de fechamento",
    identificador: "Identificador",
    naoPreenchido: "Não preenchido",
    semCampanha: "Sem campanha",
    abrir: "Abrir negociação",
  },
  // Ajustes 27/10 (C8): o formulário único de criar negociação.
  criarNeg: {
    nome: "Nome da negociação",
    nomePlaceholder: "Digite o nome da negociação",
    fonte: "Fonte",
    campanha: "Campanha",
    funil: "Funil de vendas",
    etapa: "Etapa do funil de vendas",
    etapaAjuda: "Sem escolher, a primeira etapa do funil.",
    responsavel: "Responsável",
    grupoEmpresa: "Informações da empresa",
    empresa: "Empresa da negociação",
    adicionarEmpresa: "Adicionar empresa",
    grupoContato: "Informações do contato",
    contato: "Contato",
    criarContato: "Criar contato",
    dicaCartoes: "Configure os campos que aparecem no cartão da negociação no funil, em Mais opções > Personalizar cartões.",
    salvarOutra: "Salvar e criar outra",
    criar: "Criar",
    criada: "Negociação criada",
    criadas_one: "{{count}} negociação criada",
    criadas_other: "{{count}} negociações criadas",
    semCliente: "Escolha a empresa ou o contato da negociação.",
    parcial: "{{feitos}} de {{total}} negociações criadas. As criadas saíram da lista; envie de novo para criar as que faltam.",
    contatoNaoEntrou: "A negociação foi criada, mas o contato não entrou nela. Ponha pela ficha.",
    contatosDaEmpresa: "Contatos da empresa",
    contatosDaEmpresaAjuda: "Os marcados entram na negociação junto com o contato escolhido.",
    // Lista de 03/11, item 3: várias empresas e vários contatos na criação.
    empresaPrincipalAjuda: "A primeira empresa é a principal: é o cliente da negociação nos relatórios e no faturamento.",
    selePrincipal: "Principal",
    empresasDoGrupo: "Empresas do mesmo grupo",
    empresasDoGrupoAjuda: "A matriz e as filiais desta empresa. As marcadas entram como empresas adicionais; a escolhida segue como principal.",
    empresasDoGrupoTruncado: "Mostrando as 100 primeiras do grupo. Para outra, procure em Outras empresas.",
    empresasDoGrupoLimite: "Até {{n}} empresas adicionais por negociação.",
    empresasDoGrupoErro: "Não foi possível carregar as empresas do grupo. Você pode procurá-las em Outras empresas.",
    outrasEmpresas: "Outras empresas",
    outrasEmpresasAjuda: "Entram na negociação como empresas adicionais, abaixo da principal.",
    buscarOutraEmpresa: "Adicionar outra empresa",
    criarOutraEmpresa: "Criar outra empresa",
    outrosContatos: "Outros contatos",
    outrosContatosAjuda: "Entram na negociação junto com o contato principal.",
    buscarOutroContato: "Adicionar outro contato",
    criarOutroContato: "Criar outro contato",
    tirarDaLista: "Tirar {{nome}} da lista",
    empresaNaoEntrou: "A negociação foi criada, mas alguma empresa adicional não entrou nela. Ponha pela ficha.",
  },
  filtros: {
    titulo: "Filtros",
    limpar: "Limpar filtros",
    aplicar: "Aplicar filtros",
    salvos: "Filtros salvos",
    escolherSalvo: "Escolher um filtro salvo",
    renomear: "Renomear filtro",
    excluir: "Excluir filtro",
    salvarAtual: "Salvar estes filtros",
    gravar: "Salvar",
    nomeFiltro: "Nome do filtro",
    salvo: "Filtro salvo",
    aplicado: "Filtro aplicado: {{nome}}",
    confirmarExcluir: 'Excluir o filtro "{{nome}}"?',
    predefinidos: "Filtros predefinidos",
    nenhum: "Nenhum",
    predef: {
      criadas_14: "Criadas nos últimos 14 dias",
      criadas_90: "Criadas nos últimos 3 meses",
      sem_contato_14: "Sem contato nos últimos 14 dias",
      atrasadas: "Com tarefas atrasadas",
      vendidas: "Vendidas",
      perdidas: "Perdidas",
      abertas: "Abertas",
    },
    semTarefa: "Ver só as negociações sem tarefa",
    vazios: "Campos vazios",
    campoVazio: {
      previsao: "Previsão de fechamento",
      fonte: "Fonte",
      campanha: "Campanha",
      produtos: "Produtos",
    },
    nome: "Nome da negociação",
    valorMin: "Valor total de ({{simbolo}})",
    valorMax: "Valor total até ({{simbolo}})",
    qualquerData: "Qualquer data",
    presets: {
      hoje: "Hoje",
      "7": "Últimos 7 dias",
      "14": "Últimos 14 dias",
      "30": "Últimos 30 dias",
      "90": "Últimos 3 meses",
      n7: "Próximos 7 dias",
      n30: "Próximos 30 dias",
    },
    datas: {
      criada: "Data de criação",
      contato: "Data do último contato",
      proxima: "Data da próxima tarefa",
      fechada: "Data de fechamento",
      previsao: "Previsão de fechamento",
    },
    empresa: "Empresa",
    campanha: "Campanha",
    fonte: "Fonte",
    produto: "Produto ou serviço",
    vertical: "Vertical",
    vazioEtiqueta: "Vazio: {{campo}}",
    valorEtiqueta: "Valor de {{de}} até {{ate}}",
  },
  contagem: {
    parcial:
      "{{feitos}} de {{total}} já foram feitas; o resto parou com: {{erro}}. As que faltam continuam selecionadas.",
    ajuda:
      "Para confirmar, preencha com a quantidade de itens que serão alterados.",
    placeholder: "Quantidade de itens",
    ciente: "Entendo que esta ação não pode ser desfeita.",
  },
  ficha: {
    voltar: "Voltar",
    carregando: "Carregando a negociação",
    abasRotulo: "Seções da negociação",
    etapas: "Etapas do funil",
    abas: {
      historico: "Histórico",
      email: "E-mail",
      tarefas: "Tarefas",
      questionarios: "Questionários",
      produtos: "Produtos",
      arquivos: "Arquivos",
      propostas: "Propostas",
    },
    adicionar: "Adicionar",
    adicionarContato: "Adicionar contato",
    ata_one: "Ata e {{count}} arquivo",
    ata_other: "Ata e {{count}} arquivos",
    campos: {
      nome: "Nome",
      previsao: "Previsão de fechamento",
      fechamento: "Data de fechamento",
      criada: "Criada em",
      valor: "Valor total",
      ultimoContato: "Último contato",
    },
    concluirTarefa: "Concluir a tarefa {{titulo}}",
    contatoExistente: "Contato do cadastro",
    copiado: "Copiado",
    copiar: "Copiar",
    dias_one: "{{count}} dia",
    dias_other: "{{count}} dias",
    duplicada: "Negociação duplicada",
    duplicar: "Duplicar negociação",
    editarCampo: "Editar {{campo}}",
    excluida: "Negociação excluída",
    excluir: "Excluir negociação",
    excluirTexto:
      'A negociação "{{titulo}}" e as tarefas dela vão para a lixeira por 30 dias.',
    excluirTitulo: "Excluir negociação?",
    filtroTarefas: "Tarefas",
    marcarPerda: "Marcar perda",
    marcarVenda: "Marcar venda",
    pausar: "Pausar negociação",
    retomar: "Retomar negociação",
    playbook: "Abrir playbook",
    principal: "Principal",
    proximaAcao: "Próxima ação recomendada",
    proximasTarefas: "Próximas tarefas",
    excluirTarefa: "Excluir a tarefa {{titulo}}",
    reabrirTarefa: "Reabrir a tarefa {{titulo}}",
    maisOpcoesTarefa: "Mais opções de {{titulo}}",
    cancelarReuniao: "Cancelar reunião",
    confirmarCancelarReuniao: "Cancelar esta reunião?",
    confirmarCancelarReuniaoTexto: "A reunião {{titulo}} fica cancelada aqui e também na Agenda, se foi agendada por ela.",
    reuniaoCancelada: "Reunião cancelada",
    recomendaAgendar:
      "Agende um próximo passo com o cliente para não perder o ritmo da negociação.",
    recomendaConcluir:
      'Concluir a tarefa "{{titulo}}", agendada para {{data}}.',
    removerContato: "Tirar {{nome}} da negociação",
    // Lista de 03/11, item 3: empresas adicionais na ficha da negociação.
    empresasAdicionais: "Outras empresas",
    semEmpresasAdicionais: "Nenhuma outra empresa na negociação.",
    adicionarEmpresa: "Adicionar outra empresa",
    removerEmpresa: "Tirar {{nome}} da negociação",
    secoes: {
      negociacao: "Negociação",
      contatos: "Contatos",
      empresa: "Empresa",
      responsavel: "Responsável",
    },
    semCampanha: "Sem campanha",
    semContato: "Ainda sem contato",
    semContatos: "Nenhuma pessoa de contato na negociação.",
    semPendentes: "Não há tarefas pendentes nesta negociação.",
    reuniaoAgenda: { diaInteiro: "Dia inteiro", titulo: "Reunião da Agenda", abrir: "Abrir na Agenda", semAssunto: "Reunião sem assunto", estado: { marcado: "Marcada", confirmado: "Confirmada", realizado: "Realizada", faltou: "Não ocorreu", cancelado: "Cancelada" } },
    tarefas: {
      pendentes: "Tarefas pendentes",
      concluidas: "Tarefas concluídas",
      todas: "Todas as tarefas",
      vazio: "Nenhuma tarefa neste filtro.",
    },
    tornarPrincipal: "Tornar {{nome}} o contato principal",
    whatsapp: "Abrir no WhatsApp",
    produtos: {
      adicionar: "Adicionar produto ou serviço",
      editarTitulo: "Editar produto ou serviço",
      vazio: "Não há nenhum produto ou serviço nesta negociação.",
      acoes: "Ações",
      colunas: {
        nome: "Nome e recorrência",
        quantidade: "Quantidade",
        preco: "Preço e desconto",
        subtotal: "Subtotal",
      },
      descontoPct: "Desconto: {{pct}}% ({{valor}})",
      descontoValor: "Desconto: {{valor}}",
      editar: "Editar {{nome}}",
      remover: "Remover {{nome}}",
      confirmarRemover: "Remover o produto da negociação?",
      unico: "Valor único",
      recorrente: "Valor recorrente",
      total: "Valor total",
      adicionado: "Produto adicionado",
      // Lista de 30/10 (B), itens 15 e 16.
      adicionadoOutro: "Produto adicionado. Escolha o próximo.",
      criarEOutro: "Criar e adicionar outro",
      verticalDoProduto: "Vertical do produto",
      verticalTodas: "Todas",
      atualizado: "Produto atualizado",
      passo1: "1. Escolher produto",
      passo2: "2. Configurar produto",
      catalogo: "Produto ou serviço do catálogo",
      avancar: "Avançar",
      voltar: "Voltar",
      adicionarBotao: "Adicionar produto",
      precoBase: "Preço base: {{valor}}",
      valor: "Valor unitário",
      acrescentarDesconto: "Acrescentar desconto",
      escolhaVertical: "Escolha a vertical",
      escolhaVerticalPrimeiro: "Escolha a vertical para ver os serviços oferecidos nela.",
      verticalNova: "{{nome}} (nova na negociação)",
      verticalNovaAjuda: "Esta vertical ainda não é da negociação; ao salvar o item, ela passa a valer também na negociação.",
      servicoForaDaVertical: "O serviço \"{{nome}}\" não é oferecido nesta vertical. Escolha o serviço de novo.",
      tipoDesconto: "Tipo de desconto",
      tipos: {
        percentual: "% Porcentagem",
        valor: "{{simbolo}} Valor",
      },
      valorDesconto: "Valor do desconto ({{unidade}})",
      equivalePct: "{{pct}}% = {{valor}} de desconto",
      equivaleValor: "{{valor}} = {{pct}}% do valor",
      limites: {
        negativo: "O desconto não pode ser negativo",
        percentualMaximo: "Em porcentagem, no máximo 100%",
        valorMaximo: "Em valor, no máximo {{maximo}} (valor x quantidade)",
      },
      resumoBruto: "Valor unitário x quantidade",
      resumoDesconto: "Desconto",
      resumoLiquido: "Valor do produto na negociação",
      escolha: "Escolha um produto do catálogo",
      quantidadeInvalida: "Informe uma quantidade maior que zero",
    },
  },
  proposta: {
    criar: "Criar proposta",
    nova: "Nova proposta",
    vazio:
      "Crie e envie propostas para o cliente com os produtos desta negociação.",
    semItens: "Adicione um produto à negociação para criar a proposta.",
    numero: "Proposta #{{numero}}",
    lista: {
      proposta: "Proposta",
      modelo: "Modelo",
      criada: "Criada em",
      valor: "Valor",
      status: "Status",
    },
    estados: {
      criada: "Criada",
      enviada: "Enviada",
      aceita: "Aceita",
      recusada: "Recusada",
    },
    enviarEmail: "Enviar por e-mail",
    imprimir: "Imprimir",
    imprimirDeNovo: "Abrir o PDF de novo",
    mudarStatus: "Mudar o status da proposta #{{numero}}",
    excluir: "Excluir a proposta #{{numero}}",
    acoes: "Ações",
    excluirTitulo: "Excluir a proposta #{{numero}}?",
    excluirTexto:
      "A proposta sai da negociação e volta pela Lixeira em até 30 dias. O PDF já enviado continua em Arquivos.",
    excluida: "Proposta excluída",
    impressaAberta:
      "O PDF da proposta (o mesmo que vai no e-mail) abriu em outra aba: imprima ou salve por lá. Se a aba não abriu, use o botão abaixo.",
    criarImprimir: "Criar e imprimir",
    criarEmail: "Criar e enviar por e-mail",
    criada: "Proposta criada",
    modelo: "Modelo",
    modeloPadrao: "{{nome}} (padrão)",
    previa: "Prévia",
    campos: {
      titulo: "Título",
      apresentacao: "Apresentação",
      condicoes: "Condições gerais",
      rodape: "Rodapé",
    },
    colunas: {
      produto: "Produto ou serviço",
      quantidade: "Qtd.",
      desconto: "Desconto",
      preco: "Preço",
      subtotal: "Subtotal",
    },
    semTitulo: "Proposta comercial",
    aosCuidados: "A/C: {{contato}} | {{cliente}}",
    totalPedido: "Valor total do pedido",
    itensTabela: "Itens da proposta",
    condicoes: "Condições gerais",
  },
  email: {
    criar: "Criar e-mail",
    enviar: "Enviar e-mail",
    enviado: "E-mail enviado",
    vazio: "Nenhum e-mail enviado por esta negociação.",
    para: "Para",
    paraAjuda:
      "Só o e-mail do cliente ou de uma pessoa de contato da negociação.",
    paraQuem: "Para: {{para}}",
    assunto: "Assunto",
    texto: "Mensagem",
    semAcessoCadastros:
      "Os e-mails do cliente e das pessoas de contato ficam no Cadastros, e você não tem acesso a ele. Peça a quem administra o acesso.",
    semDestino: "O cliente e as pessoas de contato não têm e-mail no cadastro.",
    comProposta:
      "Proposta #{{numero}} em PDF ({{total}})",
    assuntoProposta: "Proposta comercial #{{numero}} · {{titulo}}",
    ola: "Olá, {{nome}}!",
    olaSemNome: "Olá!",
    textoProposta:
      "{{saudacao}}\n\nSegue a proposta comercial em anexo. Fico à disposição para qualquer dúvida.\n\nAtenciosamente,\n{{autor}}",
    // Lote crm4 (L8): anexos do "Criar e-mail" (arquivos da negociação).
    anexar: "Anexar arquivo",
    anexos: "Anexos",
    anexosAjuda: "Até {{max}} arquivos, {{limite}} somados ({{porArquivo}} por arquivo): imagem, PDF, Word, Excel, PowerPoint, OpenDocument, TXT ou CSV. Os arquivos ficam também na aba Arquivos da negociação.",
    anexosAjudaProposta: "A proposta vai em PDF e conta no limite: mais {{max}} arquivos, até {{limite}} somados, mais o PDF dela ({{porArquivo}} por arquivo). Os arquivos ficam também na aba Arquivos da negociação.",
    removerAnexo: "Remover {{nome}}",
    anexoGrande: "{{nome}} passa do limite: os anexos somam até {{limite}}.",
    anexoArquivoGrande: "{{nome}} passa do limite de {{limite}} por arquivo.",
    anexoTipo: "{{nome}} não pode ir no e-mail: envie imagem, PDF, Word, Excel, PowerPoint, OpenDocument, TXT ou CSV.",
    anexosDemais: "Anexe até {{max}} arquivos.",
    enviandoAnexos: "Enviando os anexos",
  },
  questionarios: {
    vazio: "Nenhum questionário. Crie em Configurações do CRM > Questionários.",
    escolher: "Questionário",
    respondido: "{{nome}} (respondido)",
    salvar: "Salvar respostas",
    salvo: "Respostas salvas",
    concluir: "Concluir",
    salvarRascunho: "Salvar rascunho",
    rascunhoSalvo: "Rascunho salvo",
    alteradoPor: "Última alteração de {{nome}} em {{quando}}",
    excluirAplicacao: "Excluir este questionário",
    confirmarExcluirAplicacao: "Excluir este questionário da negociação?",
    confirmarExcluirAplicacaoTexto: "As respostas dele deixam de aparecer. Os outros questionários não mudam.",
    excluido: "Questionário excluído",
    novo: "Novo questionário",
    nenhum: "Nenhum questionário nesta negociação ainda. Escolha um modelo e clique em Novo questionário.",
    escolherModelo: "Modelo do questionário",
    iniciar: "Iniciar",
    iniciado: "Questionário iniciado",
    semModelos: "Nenhum modelo ativo. Crie em Configurações do CRM > Questionários.",
    lista: "Questionários da negociação",
    emAndamento: "Em andamento",
    concluido: "Concluído",
    abrir: "Abrir {{nome}}",
    recolher: "Recolher {{nome}}",
    numero: "{{nome}} · nº {{n}}",
    iniciadoEm: "Iniciado em {{quando}}",
    concluidoEm: "Concluído em {{quando}}",
    pontosResumo: "{{count}} pt",
    resumoTotal_one: "{{count}} questionário",
    resumoTotal_other: "{{count}} questionários",
    sim: "Sim",
    nao: "Não",
  },
  arquivos: {
    soltar: "Arraste e solte o arquivo aqui ou clique para escolher",
    vazio: "Nenhum arquivo nesta negociação.",
    enviados: "Arquivos enviados",
    baixar: "Baixar {{nome}}",
    excluir: "Excluir {{nome}}",
    confirmarExcluir: "Excluir o arquivo?",
  },
  pausa: {
    tituloPausar: "Pausar negociação",
    tituloRetomar: "Retomar negociação",
    textoPausar: "Conte por que esta negociação vai pausar. Enquanto estiver pausada, nada nela pode ser alterado. O motivo fica no histórico.",
    textoRetomar: "Conte por que esta negociação volta ao andamento. O motivo fica no histórico.",
    motivo: "Motivo",
    erroMotivo: "Informe o motivo, de {{min}} a {{max}} caracteres.",
    confirmarPausar: "Pausar",
    confirmarRetomar: "Retomar",
    aviso: "Negociação pausada: retome para poder alterá-la.",
    naoMove: "Negociação pausada: retome antes de mover de etapa.",
    naoEncerra: "Negociação pausada: retome antes de marcar venda ou perda.",
  },
  playbook: {
    titulo: "Orientações por etapa",
    ajuda:
      "O que fazer em cada etapa do funil, e os itens para conferir nesta negociação.",
    objetivo: "Objetivo da etapa",
    descricao: "Descrição",
    semObjetivo: "O objetivo da etapa ainda não foi configurado.",
    semDescricao: "A descrição ainda não foi configurada.",
    configurar: "Configurar o playbook",
  },
};

type DicCrm = typeof crmPt;

export const cascaEn: typeof cascaPt = {
  comercial: "Sales",
  atividades: "Activities",
  configuracoes: "CRM settings",
  central: "File library",
  relatorios: "Reports",
};

export const crmEn: DicCrm = {
  atividades: {
    titulo: "Activities",
    criar: "Create task",
    todasTarefas: "All tasks",
    nResponsaveis_one: "{{count}} owner",
    nResponsaveis_other: "{{count}} owners",
    responsaveis: "Owners",
    minhas: "Mine only",
    buscarResponsavel: "Search owner",
    qualquerPeriodo: "Any period",
    periodo: "Period",
    periodos: {
      hoje: "Today",
      semana: "This week",
      mes: "This month",
      "7": "Last 7 days",
      "14": "Last 14 days",
      "30": "Last 30 days",
      "180": "Last 6 months",
      personalizado: "Custom period",
    },
    de: "From",
    ate: "To",
    todosTipos: "All task types",
    nTipos_one: "{{count}} task type",
    nTipos_other: "{{count}} task types",
    situacao: "Status",
    situacoes: {
      atrasadas: "Overdue",
      pendentes: "Pending",
      concluidas: "Completed",
      todas: "All statuses",
    },
    limparFiltros: "Clear filters",
    resumoSemana: "Task summary for this week",
    diasDaSemana: "From {{de}} to {{ate}}",
    funil: "Pipeline",
    todosFunis: "All pipelines",
    criadas: "Created",
    concluidas: "Completed",
    abertasEmDia: "Open and on time",
    atrasadas: "Overdue",
    colunas: {
      tarefa: "Tasks",
      status: "Status",
      dataHora: "Date and time",
      responsaveis: "Owners",
      negociacao: "Deal",
      valor: "Total value",
    },
    status: {
      atrasada: "Overdue",
      hoje: "Due today",
      futura: "Scheduled",
      concluida: "Completed",
      cancelada: "Cancelled",
    },
    selecionar: "Select {{nome}}",
    selecionarPagina: "Select the tasks on this page",
    selecionados_one: "{{count}} selected",
    selecionados_other: "{{count}} selected",
    limparSelecao: "Clear selection",
    selecionarTodos: "Select all {{count}} items in this filter",
    selecionarTodosLimite:
      "Select the first {{limite}} of {{count}} items in this filter",
    acoesMassa: "Actions on the selected tasks",
    adiar: "Postpone task",
    adiarModos: {
      hora1: "In 1 hour",
      hora2: "In 2 hours",
      amanha: "To tomorrow",
      dias2: "In 2 days",
      semana: "To next week",
      mes: "To next month",
    },
    exportar: "Export",
    transferir: "Transfer task",
    atribuir: "Assign owner",
    concluir: "Mark as completed",
    escolherResponsavel: "Choose the owner",
    confirmarLote_one: "Apply to {{count}} task?",
    confirmarLote_other: "Apply to {{count}} tasks?",
    confirmarTransferir: "{{nome}} becomes the only owner.",
    confirmarAtribuir: "{{nome}} is added as another owner.",
    resultado: "{{alterados}} changed; {{ignorados}} unchanged",
    exportado: "Export ready",
    arquivoCsv: "tasks.csv",
    sobre: "About the deal",
    vazio: "No tasks found.",
    reuniaoNaAgenda: "Meeting booked in the Schedule",
    editar: "Edit task",
    verAta: "See the minutes",
    ataArquivos: "Attached files",
    ataArquivosFora_one: "{{count}} file is no longer in the deal.",
    ataArquivosFora_other: "{{count}} files are no longer in the deal.",
    ata: "Task minutes",
    concluidaEm: "Completed on {{data}}",
    abrirNegociacao: "Open the deal",
    sobreNegociacao: "About the deal",
    editarTarefa: "Edit the task {{titulo}}",
    filtrosLigados: "Active filters",
    filtrosN: "Filters ({{n}})",
    filtrosTitulo: "Filters",
    aplicarFiltros: "Apply filters",
    periodoAgendamento: "Scheduling period",
    tirarFiltro: "Remove the filter {{filtro}}",
    verRelatorio: "See full report",
    configurar: "Sales workflows",
  },
  form: {
    criarTitulo: "Create task",
    editarTitulo: "Edit task",
    proximaTitulo: "Create next task",
    empresa: "Deal company",
    negociacao: "Deal",
    selecionar: "Select",
    criarNegociacao: "Create a deal for this task",
    assunto: "Task subject",
    descricao: "Task description",
    responsaveis: "Owners",
    principal: "main",
    tipo: "Task type",
    dataHora: "Date and time",
    concluirAoCriar: "Mark as completed when creating",
    dica: "Create tasks automatically: the sales workflows suggest the next task when one is completed.",
    conhecerWorkflows: "See the sales workflows",
    semResponsavel: "Choose at least one owner",
    obrigatorio: "Required field",
    selecioneNegociacao: "Select the deal",
    criada: "Task created",
    criadaComMeet: "Task created. The Google Meet link shows up in the meeting in a moment.",
    descricaoLonga: "The meeting description can have up to {{max}} characters.",
    atualizada: "Task updated",
    cancelarTarefa: "Cancel task",
    confirmarCancelar: "Cancel this task?",
    confirmarCancelarTexto:
      "It leaves the pending list and stays in the deal history as cancelled.",
    cancelada: "Task cancelled",
    excluir: "Delete",
    excluida: "Task deleted",
    confirmarExcluir: "Delete task",
    confirmarExcluirTexto: "The task will be deleted and removed from the lists and the task history. This cannot be undone.",
    adicionarResponsavel: "Add owner",
    removerResponsavel: "Remove {{nome}}",
    justificativa: "Justification",
    justificativaAjuda: "It stays in the deal history (10 to 500 characters).",
    reabrirTitulo: "Reopen task",
    reabrir: "Reopen",
    reaberta: "Task reopened",
    reabrirDica: "The cancelled task goes back to pending when you save. Change whatever you need.",
    data: "Scheduled date",
    horario: "Task time",
    reuniaoAgenda:
      "Meeting booked in the Schedule: change the time in the Schedule.",
    descricaoConvidados: "Guests receive this description.",
    agendarNaAgenda: "Book in the Schedule and on Google",
    agendarNaAgendaAjuda:
      "Clear it to only log the activity (a meeting already held or booked elsewhere).",
    servico: "Service",
    recurso: "Resource (whose calendar it is)",
    escolhaHorario: "Pick a free time slot.",
  },
  atalho: {
    titulo: "Tasks and meetings",
    verHoje: "See today",
    semana: "Week",
    semanaAnterior: "Previous week",
    proximaSemana: "Next week",
    todas: "Show everyone's tasks and meetings",
    carregando: "Loading...",
    vazioTitulo: "No pending tasks or meetings",
    vazioTexto: "Try selecting another date or use the button below to see all your tasks.",
    irTarefas: "Go to tasks page",
    abrirReuniao: "Open the meeting in the Schedule",
    semTarefa: "See deals without tasks",
  },
  semNegociacao: {
    titulo: "This task needs a deal",
    texto:
      "Every task is linked to a deal. You can choose an existing one or create the deal now.",
    guardado:
      "What you already typed in the task is kept and comes back filled in.",
    escolher: "Choose an existing one",
    criar: "Create deal",
  },
  negociacaoTarefa: {
    titulo: "Create a deal for the task",
    aviso:
      "The task you were creating was kept. When you create the deal, it comes back filled in and already linked to it.",
    criarVoltar: "Create and go back to the task",
    voltar: "Back to the task",
  },
  concluir: {
    titulo: "Complete task",
    tituloVarias_one: "Complete {{count}} task",
    tituloVarias_other: "Complete {{count}} tasks",
    intro:
      "To complete it, record the minutes or a summary of what was done. Use an example or insert what the CRM already knows about the deal; attachments are optional. Everything goes to the deal history.",
    mesmaAta: "The same minutes and files apply to all of them.",
    exemplos: "Minutes examples",
    ata: "Minutes / summary of what was done",
    ataAjuda:
      "Click an example to start; the [ ] parts are for you to fill in (Tab jumps to the next one).",
    ataPlaceholder: "What was discussed, decided and the next step agreed",
    inserir: "Insert from the system",
    inserirAjuda: "(goes where the cursor is)",
    arquivos: "Files",
    opcional: "(optional)",
    naNegociacao: "Documents already in the deal",
    grupoArquivos: "Deal files",
    anexarNovo: "Attach a new file",
    removerArquivo: "Remove {{nome}}",
    botao: "Complete task",
    botaoVarias: "Complete tasks",
    concluida: "Task completed with the minutes",
    concluidas: "Tasks completed with the minutes",
    erroCurta: "Write the minutes or summary (at least 10 characters)",
    erroLacuna:
      "Fill in the [ ] parts of the example (or delete the ones that do not apply)",
  },
  inserir: {
    negociacao: "Deal",
    empresa: "Company",
    contato: "Contact",
    produtos: "Products",
    ultimaAnotacao: "Last note",
    ataAnterior: "Previous minutes",
    proximaReuniao: "Next meeting",
    negociacaoTxt: "Deal {{nome}} · stage {{etapa}} · value {{valor}}",
    empresaTxt: "Company: {{nome}}",
    contatoTxt: "Contact: {{nome}}{{extra}}",
    produtosTxt: "Products: {{lista}}",
    anotacaoTxt: "Note from {{data}}: {{texto}}",
    ataAnteriorTxt: 'In the previous task ("{{titulo}}"): {{ata}}',
    reuniaoTxt: 'Next meeting: "{{titulo}}" on {{data}}',
    ultimaProposta: "Last proposal",
    ultimoEmail: "Last e-mail",
    propostaTxt: "Proposal #{{numero}} ({{estado}}) from {{data}} · value {{valor}}{{para}}",
    enviadaPara: " · sent to {{email}}",
    emailTxt: 'E-mail from {{data}}{{para}}: "{{assunto}}" · {{texto}}',
    paraEmail: " to {{email}}",
  },
  ata: {
    ocliente: "the customer",
    aempresa: "the company",
    noTelefone: " at {{fone}}",
    hojeEm: " (now in {{etapa}})",
    modeloDe: "{{tipo}} template",
    modelos: {
      tarefa: 'Task "{{titulo}}" completed. Result: [ ]. Next step: [ ].',
      ligacao:
        'I called {{quem}} ({{emp}}){{fone}}. We talked about "{{titulo}}". We agreed: [ ]. Next step: [ ].',
      reuniao:
        "Meeting with {{quem}} from {{emp}} on {{data}}. Agenda: {{titulo}}. Decisions: [ ]. Customer to-dos: [ ]. Next step: [ ].",
      email:
        'Email sent to {{quem}}{{mail}} about "{{titulo}}". Waiting for a reply until [ ].',
      whatsapp:
        'WhatsApp message sent to {{quem}}{{fone}} about "{{titulo}}". Customer reply: [ ].',
      visita:
        "Visit to {{emp}}, received by {{quem}}. What we saw: [ ]. Agreed: [ ]. Next step: [ ].",
      almoco: "Lunch with {{quem}} ({{emp}}). Topics: [ ]. Agreed: [ ].",
    },
    situacoes: {
      avancou: "Moved forward",
      semRetorno: "No reply",
      pediuProposta: "Asked for a proposal",
      feito: "Done as agreed",
    },
    textos: {
      avancou:
        "{{quem}} approved the next step: [ ]. The deal{{etapa}} moves to [ ].",
      semRetorno:
        "I tried to reach {{quem}} with no reply. Next attempt on [ ].",
      pediuProposta: "{{quem}} asked for the proposal with [ ]. Send by [ ].",
      feito: "Task completed as agreed. Result: [ ].",
      semRetornoMassa:
        "I tried to reach the customer with no reply. Next attempt on [ ].",
    },
  },
  proxima: {
    anteriores: "Summary of previous tasks",
    semAnteriores: "No task was completed before in this deal.",
    sugestoes: "Next task suggestions",
    sugestoesAjuda:
      "From the sales workflows and from what was written in the minutes. Click to use; you can edit everything below.",
    emDias_one: "in {{count}} day",
    emDias_other: "in {{count}} days",
    motivoWorkflow: 'Workflow "{{nome}}", step {{passo}}',
    motivoAta: "From the summary: it mentions {{palavra}}",
    motivoPadrao: "Default suggestion",
    configurar: "Set up workflows",
    descricaoPadrao: 'Next step after "{{titulo}}".',
  },
  pistas: {
    proposta: "Send the sales proposal",
    contrato: "Send the contract for signature",
    reuniao: "Presentation meeting",
    documentos: "Chase pending documents",
    retorno: "Call back",
    whatsapp: "Follow-up message",
    padrao: "Follow-up",
    palavra: {
      proposta: "a proposal",
      contrato: "a contract",
      reuniao: "a meeting",
      documentos: "documents",
      retorno: "a call back",
      whatsapp: "WhatsApp",
    },
  },
  workflows: {
    titulo: "Sales workflows",
    intro1:
      'Create as many workflows as you need, each with its own process (consultative sale, renewal, after-sales...). Each workflow has steps: when someone completes a task, the CRM opens "Create next task" with the summary of previous tasks and the suggestions of the active workflows.',
    intro2:
      "Suggestions also come from what was written in the minutes (for example, if the minutes mention a proposal, it suggests sending the proposal).",
    abrirProxima: 'Open "Create next task" when a task is completed',
    n_one: "{{count}} workflow",
    n_other: "{{count}} workflows",
    criar: "Create workflow",
    editar: "Edit",
    duplicar: "Duplicate",
    excluir: "Delete",
    confirmarExcluir: 'Delete "{{nome}}"?',
    confirmarExcluirTexto_one:
      "The workflow and its step are removed. Tasks already created do not change.",
    confirmarExcluirTexto_other:
      "The workflow and its {{count}} steps are removed. Tasks already created do not change.",
    vazio:
      "No workflows. Suggestions come only from the minutes until you create one.",
    usarExemplos: "Create the examples",
    todosFunis: "All pipelines",
    passos_one: "{{count}} step",
    passos_other: "{{count}} steps",
    desligadoSelo: "off",
    ligar: "Turn on workflow {{nome}}",
    ligado: "Workflow turned on",
    desligado: "Workflow turned off",
    criado: "Workflow created",
    atualizado: "Workflow updated",
    duplicado: "Workflow duplicated",
    excluido: "Workflow deleted",
    salvo: "Setting saved",
    copia: "{{nome}} (copy)",
    nome: "Workflow name",
    nomePlaceholder: "E.g.: Consultative sale, Renewal, After-sales",
    valePara: "Applies to",
    passos: "Steps",
    passo: "Step {{n}}",
    removerPasso: "Remove step {{n}}",
    quando: "When completing",
    qualquer: "Any task",
    etapa: "In stage",
    qualquerEtapa: "Any stage",
    sugerir: "Suggest",
    assunto: "Subject",
    assuntoPlaceholder: "E.g.: Send the sales proposal",
    dias: "In (days)",
    adicionarPasso: "Add step",
    passoSemAssunto: "Step {{n}}: enter the subject of the suggested task",
    previa:
      "When completing {{quando}}{{etapa}} → suggest {{tipo}} · {{assunto}} {{dias}}",
    previaQualquer: "any task",
    previaEtapa: " in stage {{etapa}}",
    exemplos: {
      vendaConsultiva: "Consultative sale",
      posVenda: "After-sales and relationship",
      diagnostico: "Discovery meeting",
      proposta: "Send the sales proposal",
      acompanhamento: "Proposal follow-up call",
      agradecer: "Thank them for the visit",
      resumo: "Send the summary of what was agreed",
    },
  },
  configuracoes: {
    titulo: "CRM settings",
    secoes: {
      funis: "Sales pipelines",
      campos: "Set up fields",
      motivos: "Loss reason",
      fontes: "Sources and campaigns",
      qualificacao: "Qualification",
      questionarios: "Questionnaires",
      modelos: "Proposal templates",
      workflows: "Sales workflows",
      "status-proposta": "Proposal statuses",
    },
    salvo: "Settings saved",
    salvar: "Save",
    statusProposta: {
      intro: "The statuses shown in each proposal's menu. Each status follows a base state (created, sent, accepted or declined), which is what the CRM rules use.",
      criar: "Create status",
      editar: "Edit status",
      nome: "Status name",
      cor: "Color",
      estadoBase: "Base state",
      estadoBaseAjuda: "The CRM rules read the base state: sending the proposal, for example, moves a created one to the \"sent\" status.",
      estadoBaseTravado: "The base state of default statuses and of statuses in use doesn't change.",
      ativo: "Active",
      inativo: "Inactive",
      fabrica: "Default",
      emUso_one: "{{count}} proposal",
      emUso_other: "{{count}} proposals",
      subir: "Move {{nome}} up",
      descer: "Move {{nome}} down",
      ativar: "Activate {{nome}}",
      desativar: "Deactivate {{nome}}",
      editarNome: "Edit {{nome}}",
      emUsoAviso: "To deactivate it, first move the proposals in this status to another one.",
      cores: { neutro: "Gray", acento: "Malgo green", roxo: "Purple", azul: "Blue", ciano: "Cyan", laranja: "Orange", dourado: "Yellow", verde: "Green", perigo: "Red" },
    },
    funis: {
      intro: "The pipelines and the stages deals go through. In each open stage, the playbook states the goal and the items to check.",
      gerir: "Create and organize pipelines",
      adicionarEtapa: "Add stage",
      probabilidade: "{{n}}% chance",
      comPlaybook: "With playbook",
      configurarEtapa: "Configure stage",
      excluirEtapa: "Delete stage {{nome}}",
      subirEtapa: "Move stage {{nome}} earlier",
      descerEtapa: "Move stage {{nome}} later",
      confirmarExcluir: "Delete stage {{nome}}?",
      confirmarExcluirTexto: "Only a stage with no deals can be deleted. The pipeline must keep one open, one won and one lost stage.",
      probabilidadeInvalida: "Use a whole number from 0 to 100",
      nomeEtapa: "Stage name",
      itensPlaybook: "Items to check",
      itemN: "Item {{n}}",
      removerItem: "Remove item {{n}}",
      adicionarItem: "Add item",
    },
    campos: {
      intro: "Custom fields for deals live in the system fields screen, together with those of other modules.",
      abrir: "Open custom fields",
      ajuda: "Choose the Opportunity entity to see and create sales fields.",
    },
    fontes: {
      ajuda: "Sources and campaigns show up as options in the deal record and in the Sales filters.",
      fontes: "Sources",
      campanhas: "Campaigns",
      livres: {
        fontes: "Allow typing a source not on the list",
        campanhas: "Allow typing a campaign not on the list",
      },
      vazio: "No items yet.",
      excluir: "Delete {{nome}}",
      nome: {
        fontes: "New source",
        campanhas: "New campaign",
      },
      descricao: "Description",
      adicionar: "Add",
    },
    qualificacao: {
      semNome: "Name every level",
      intro: "Qualification goes from 1 to 5 stars. Name each level; the name shows when hovering the stars.",
      nivel: "Name of level {{n}}",
      ajuda: "Deals already qualified keep their number of stars; only the name changes.",
    },
    questionarios: {
      intro: "Questions the salesperson answers in the deal record, on the Questionnaires tab.",
      criar: "Create questionnaire",
      editar: "Edit questionnaire",
      vazio: "No questionnaires yet.",
      ligar: "Use questionnaire {{nome}}",
      perguntas_one: "{{count}} question",
      perguntas_other: "{{count}} questions",
      confirmarExcluir: "Delete questionnaire {{nome}}?",
      confirmarExcluirTexto: "Answers already given in deals will no longer show.",
      semOpcoes: "Enter at least one option",
      nome: "Questionnaire name",
      pergunta: "Question {{n}}",
      removerPergunta: "Remove question {{n}}",
      texto: "Question",
      tipo: "Answer type",
      tipos: {
        texto: "Text",
        sim_nao: "Yes or no",
        opcoes: "List of options",
        numero: "Number",
      },
      obrigatoria: "Answer required",
      opcoes: "Options",
      opcoesAjuda: "One option per line.",
      adicionarPergunta: "Add question",
    },
    modelos: {
      intro: "Templates set the color and the starting texts of proposals. The default template is preselected when creating a proposal.",
      criar: "Create template",
      editar: "Edit template",
      rascunho: "Draft",
      tornarPadrao: "Make default",
      confirmarExcluir: "Delete template {{nome}}?",
      confirmarExcluirTexto: "Proposals already created with it stay as they are.",
      nome: "Template name",
      cor: "Color",
      publicado: "Available to salespeople",
    },
    semPermissao: "Only people who edit sales can change these settings.",
  },
  comercial: {
    titulo: "Pipeline",
    subtitulo: "Your deals in progress, stage by stage",
    visao: "View",
    visoes: {
      funil: "Pipeline",
      lista: "List",
    },
    estatisticasEtapas: "Stage statistics",
    sobre: "About the deal",
    sobreDe: "About the deal {{nome}}",
    recarregar: "Reload",
    recarregado: "Reloaded",
    recarregarEtapa: "Reload stage",
    recarregarEtapaDe: "Reload the stage {{etapa}}",
    etapaRecarregada: "Stage reloaded",
    configurarFunil: "Configure pipeline",
    avanco: "Pipeline progress",
    avancoAjuda: "Position of this stage among the open stages of the pipeline: how much of the way a deal has gone when it gets here",
    adicionarValor: "Add value",
    maisOpcoes: "More options",
    configurarFunis: "Set up pipelines",
    personalizarCartoes: "Customize cards",
    criar: "Create",
    criarNegociacao: "Create deal",
    todasNegociacoes: "All deals",
    minhasNegociacoes: "My deals",
    etapa: "Pipeline stage",
    todasEtapas: "All stages",
    status: "Deal status",
    statusFiltro: {
      todos: "All statuses",
      andamento: "In progress",
      vendido: "Won",
      perdido: "Lost",
      pausado: "Paused",
      nao_pausado: "Not paused",
    },
    ordenacao: "Sort by",
    ordens: {
      az: "Alphabetical A-Z",
      za: "Alphabetical Z-A",
      criadas_ultimo: "Newest first",
      criadas_primeiro: "Oldest first",
      proxima_tarefa: "Next task date",
      previsao: "Expected close",
      contato_recente: "Most recent contact",
      contato_antigo: "Oldest contact",
      mais_qualificadas: "Highest rated",
      menos_qualificadas: "Lowest rated",
      maior_valor: "Highest total value",
      menor_valor: "Lowest total value",
      interacao_recente: "Most recent interaction",
      interacao_antiga: "Oldest interaction",
    },
    filtrosN: "Filters ({{n}})",
    filtrosLigados: "Active filters",
    nNegociacoes_one: "{{count}} deal",
    nNegociacoes_other: "{{count}} deals",
    tirarFiltro: "Remove filter {{filtro}}",
    estatisticaEtiqueta: "Stage statistic: {{nome}}",
    moverSoAbertas: "To win or lose, use the deal actions",
    cartoesSalvos: "Cards updated",
    cartoesAjuda:
      "Choose the fields shown on the deal card in the pipeline. It applies to the whole workspace.",
    camposCartao: {
      empresa: "Company / contact",
      qualificacao: "Rating",
      responsavel: "Owner",
      valor: "Total value",
      proxima_tarefa: "Next task",
      criada_em: "Created on",
      fonte: "Source",
      previsao: "Expected close",
      vertical: "Vertical",
      regime: "Intended tax regime",
    },
    statusNeg: {
      andamento: "In progress",
      vendido: "Won",
      perdido: "Lost",
      pausado: "Paused",
    },
    semTarefas: "No tasks",
    criadaEm: "Created on {{data}}",
    fonteCartao: "Source: {{fonte}}",
    previsaoCartao: "Expected: {{data}}",
    regimeCartao: "Regime: {{regime}}",
    estrelas_one: "{{count}} star",
    estrelas_other: "{{count}} stars",
    qualificacao: "Rating",
    estatisticas: {
      andamento: "In progress",
      sem_tarefa: "No tasks",
      atrasadas: "With overdue tasks",
      sem_produtos: "No products or services",
    },
    mostrarEstatisticas: "Show statistics for {{etapa}}",
    esconderEstatisticas: "Hide statistics for {{etapa}}",
    conversao: "Stage conversion",
    conversaoAjuda:
      "Of the {{entraram}} deals in the pipeline that reached this stage, {{avancaram}} moved to a later stage or were won",
    conversaoDe: "({{avancaram}} of {{entraram}})",
    mostrandoDe:
      "Showing {{n}} of {{total}}: use the filters or the list to see the rest",
    resultado: "{{alterados}} changed; {{ignorados}} unchanged",
    exportCab: [
      "Name",
      "Company",
      "Stage",
      "Status",
      "Owner",
      "Rating",
      "Source",
      "Campaign",
      "One-time value",
      "Recurring value",
      "Created on",
      "Expected close",
    ],
    arquivoCsv: "deals.csv",
    exportadas_one: "{{count}} deal exported",
    exportadas_other: "{{count}} deals exported",
    selecionadas_one: "{{count}} selected",
    selecionadas_other: "{{count}} selected",
    selecionarPagina: "Select the deals on this page",
    colunas: {
      negociacao: "Deals",
      responsavel: "Owner",
      qualificacao: "Rating",
      etapa: "Pipeline stage",
      valor: "Total value",
      criacao: "Created on",
      status: "Status",
    },
    unico: "One-time: {{valor}}",
    recorrente: "Recurring: {{valor}}",
    vazio: "No deals found.",
    exibindo: "Showing",
    porPagina: "Deals per page",
    deTotal: "of {{total}}",
    anterior: "Previous",
    proxima: "Next",
    lote: {
      transferir: "Transfer",
      status: "Change status",
      campo: "Add or change",
      tarefa: "Create task",
      mover: "Move",
      excluir: "Delete",
      transferirTitulo: "Transfer the deals?",
      transferirTexto: "You are transferring {{n}} to {{nome}}.",
      perguntaTransferir: "How many deals will be transferred?",
      transferirBotao: "Transfer deals",
      statusTitulo: "Change the status of the deals?",
      statusTexto: "You are changing the status of {{n}} to {{status}}.",
      perguntaAlterar: "How many deals will be changed?",
      statusBotao: "Change status",
      campoTitulo: "Add or change {{campo}}",
      campoTexto: "You are changing the {{campo}} of {{n}}.",
      campoBotao: "Add or change",
      produtoTexto: "You are adding a product or service to {{n}}.",
      tarefaTitulo: "Create a task for the selected deals",
      tarefaTexto:
        "One task in each of the {{n}}, with the owner of each deal.",
      perguntaCriar: "For how many deals?",
      tarefaBotao: "Create tasks",
      moverTitulo: "Move deals",
      moverTexto: "You are moving {{n}} to another pipeline stage.",
      moverBotao: "Move deals",
      excluirTitulo: "Delete deals",
      excluirTexto:
        "You are deleting {{n}}, with their tasks. They stay 30 days in the trash.",
      perguntaExcluir: "How many deals will be deleted?",
      excluirBotao: "Delete deals",
    },
  },
  sobre: {
    etapa: "Stage",
    hoje: "Entered today",
    haDias_one: "{{count}} day in this stage",
    haDias_other: "{{count}} days in this stage",
    funil: "Pipeline",
    responsavel: "Owner",
    semResponsavel: "No owner",
    empresa: "Company",
    contatoPrincipal: "Main contact",
    semContato: "No contact",
    vertical: "Vertical",
    produtos: "Products",
    semProdutos: "No products",
    maisN: "+{{count}}",
    origem: "Origin",
    atividades: "Activities",
    nPendentes_one: "{{count}} pending",
    nPendentes_other: "{{count}} pending",
    nAtrasadas_one: "{{count}} overdue",
    nAtrasadas_other: "{{count}} overdue",
    ultimaAtividade: "Last: {{tipo}} · {{titulo}} on {{quando}}",
    semUltimaAtividade: "No completed activity",
    questionarios: "Questionnaires",
    nEmAndamento_one: "{{count}} in progress",
    nEmAndamento_other: "{{count}} in progress",
    nConcluidos_one: "{{count}} completed",
    nConcluidos_other: "{{count}} completed",
    semQuestionarios: "No questionnaires",
    propostas: "Proposals",
    propostaN: "Proposal no. {{n}}",
    semPropostas: "No proposals",
    camposPersonalizados: "Custom fields",
    dadosGerais: "General data",
    fonte: "Source",
    campanha: "Campaign",
    interacoes: "Interactions",
    nInteracoes_one: "{{count}} interaction",
    nInteracoes_other: "{{count}} interactions",
    ultimaAnotacao: "Last note",
    semAnotacao: "No note has been made for this deal",
    criacao: "Created on",
    ultimoContato: "Last contact",
    previsao: "Expected close",
    identificador: "Identifier",
    naoPreenchido: "Not filled in",
    semCampanha: "No campaign",
    abrir: "Open deal",
  },
  criarNeg: {
    nome: "Deal name",
    nomePlaceholder: "Type the deal name",
    fonte: "Source",
    campanha: "Campaign",
    funil: "Sales pipeline",
    etapa: "Pipeline stage",
    etapaAjuda: "If not chosen, the first stage of the pipeline.",
    responsavel: "Owner",
    grupoEmpresa: "Company information",
    empresa: "Deal company",
    adicionarEmpresa: "Add company",
    grupoContato: "Contact information",
    contato: "Contact",
    criarContato: "Create contact",
    dicaCartoes: "Choose the fields shown on the deal card in the pipeline, in More options > Customize cards.",
    salvarOutra: "Save and create another",
    criar: "Create",
    criada: "Deal created",
    criadas_one: "{{count}} deal created",
    criadas_other: "{{count}} deals created",
    semCliente: "Choose the company or the contact of the deal.",
    parcial: "{{feitos}} of {{total}} deals created. The created ones left the list; send again to create the rest.",
    contatoNaoEntrou: "The deal was created, but the contact was not added to it. Add it from the deal page.",
    contatosDaEmpresa: "Company contacts",
    contatosDaEmpresaAjuda: "The checked ones join the deal along with the chosen contact.",
    // Lista de 03/11, item 3: várias empresas e vários contatos na criação.
    empresaPrincipalAjuda: "The first company is the main one: it is the deal's customer in reports and billing.",
    selePrincipal: "Main",
    empresasDoGrupo: "Companies in the same group",
    empresasDoGrupoAjuda: "The head office and branches of this company. Checked ones join as additional companies; the chosen one stays as the main one.",
    empresasDoGrupoTruncado: "Showing the first 100 in the group. For another one, search in Other companies.",
    empresasDoGrupoLimite: "Up to {{n}} additional companies per deal.",
    empresasDoGrupoErro: "Could not load the companies in the group. You can search for them in Other companies.",
    outrasEmpresas: "Other companies",
    outrasEmpresasAjuda: "They join the deal as additional companies, below the main one.",
    buscarOutraEmpresa: "Add another company",
    criarOutraEmpresa: "Create another company",
    outrosContatos: "Other contacts",
    outrosContatosAjuda: "They join the deal along with the main contact.",
    buscarOutroContato: "Add another contact",
    criarOutroContato: "Create another contact",
    tirarDaLista: "Remove {{nome}} from the list",
    empresaNaoEntrou: "The deal was created, but an additional company was not added to it. Add it from the deal page.",
  },
  filtros: {
    titulo: "Filters",
    limpar: "Clear filters",
    aplicar: "Apply filters",
    salvos: "Saved filters",
    escolherSalvo: "Choose a saved filter",
    renomear: "Rename filter",
    excluir: "Delete filter",
    salvarAtual: "Save these filters",
    gravar: "Save",
    nomeFiltro: "Filter name",
    salvo: "Filter saved",
    aplicado: "Filter applied: {{nome}}",
    confirmarExcluir: 'Delete the filter "{{nome}}"?',
    predefinidos: "Preset filters",
    nenhum: "None",
    predef: {
      criadas_14: "Created in the last 14 days",
      criadas_90: "Created in the last 3 months",
      sem_contato_14: "No contact in the last 14 days",
      atrasadas: "With overdue tasks",
      vendidas: "Won",
      perdidas: "Lost",
      abertas: "Open",
    },
    semTarefa: "Show only deals without tasks",
    vazios: "Empty fields",
    campoVazio: {
      previsao: "Expected close",
      fonte: "Source",
      campanha: "Campaign",
      produtos: "Products",
    },
    nome: "Deal name",
    valorMin: "Total value from ({{simbolo}})",
    valorMax: "Total value up to ({{simbolo}})",
    qualquerData: "Any date",
    presets: {
      hoje: "Today",
      "7": "Last 7 days",
      "14": "Last 14 days",
      "30": "Last 30 days",
      "90": "Last 3 months",
      n7: "Next 7 days",
      n30: "Next 30 days",
    },
    datas: {
      criada: "Creation date",
      contato: "Last contact date",
      proxima: "Next task date",
      fechada: "Close date",
      previsao: "Expected close",
    },
    empresa: "Company",
    campanha: "Campaign",
    fonte: "Source",
    produto: "Product or service",
    vertical: "Vertical",
    vazioEtiqueta: "Empty: {{campo}}",
    valorEtiqueta: "Value from {{de}} to {{ate}}",
  },
  contagem: {
    parcial:
      "{{feitos}} of {{total}} were already done; the rest stopped with: {{erro}}. The remaining ones are still selected.",
    ajuda: "To confirm, fill in the number of items that will be changed.",
    placeholder: "Number of items",
    ciente: "I understand this action cannot be undone.",
  },
  ficha: {
    voltar: "Back",
    carregando: "Loading the deal",
    abasRotulo: "Deal sections",
    etapas: "Pipeline stages",
    abas: {
      historico: "History",
      email: "Email",
      tarefas: "Tasks",
      questionarios: "Questionnaires",
      produtos: "Products",
      arquivos: "Files",
      propostas: "Proposals",
    },
    adicionar: "Add",
    adicionarContato: "Add contact",
    ata_one: "Minutes and {{count}} file",
    ata_other: "Minutes and {{count}} files",
    campos: {
      nome: "Name",
      previsao: "Expected close",
      fechamento: "Close date",
      criada: "Created on",
      valor: "Total value",
      ultimoContato: "Last contact",
    },
    concluirTarefa: "Complete the task {{titulo}}",
    contatoExistente: "Contact from records",
    copiado: "Copied",
    copiar: "Copy",
    dias_one: "{{count}} day",
    dias_other: "{{count}} days",
    duplicada: "Deal duplicated",
    duplicar: "Duplicate deal",
    editarCampo: "Edit {{campo}}",
    excluida: "Deal deleted",
    excluir: "Delete deal",
    excluirTexto:
      'The deal "{{titulo}}" and its tasks go to the trash for 30 days.',
    excluirTitulo: "Delete deal?",
    filtroTarefas: "Tasks",
    marcarPerda: "Mark as lost",
    marcarVenda: "Mark as won",
    pausar: "Pause deal",
    retomar: "Resume deal",
    playbook: "Open playbook",
    principal: "Main",
    proximaAcao: "Recommended next action",
    proximasTarefas: "Upcoming tasks",
    excluirTarefa: "Delete the task {{titulo}}",
    reabrirTarefa: "Reopen the task {{titulo}}",
    maisOpcoesTarefa: "More options for {{titulo}}",
    cancelarReuniao: "Cancel meeting",
    confirmarCancelarReuniao: "Cancel this meeting?",
    confirmarCancelarReuniaoTexto: "The meeting {{titulo}} is cancelled here and also in the Schedule, if it was booked there.",
    reuniaoCancelada: "Meeting cancelled",
    recomendaAgendar:
      "Schedule a next step with the customer to keep the deal moving.",
    recomendaConcluir:
      'Complete the task "{{titulo}}", scheduled for {{data}}.',
    removerContato: "Remove {{nome}} from the deal",
    // Lista de 03/11, item 3: empresas adicionais na ficha da negociação.
    empresasAdicionais: "Other companies",
    semEmpresasAdicionais: "No other company in the deal.",
    adicionarEmpresa: "Add another company",
    removerEmpresa: "Remove {{nome}} from the deal",
    secoes: {
      negociacao: "Deal",
      contatos: "Contacts",
      empresa: "Company",
      responsavel: "Owner",
    },
    semCampanha: "No campaign",
    semContato: "No contact yet",
    semContatos: "No contact people in the deal.",
    semPendentes: "There are no pending tasks in this deal.",
    reuniaoAgenda: { diaInteiro: "All day", titulo: "Schedule meeting", abrir: "Open in the Schedule", semAssunto: "Meeting without a subject", estado: { marcado: "Scheduled", confirmado: "Confirmed", realizado: "Held", faltou: "Did not happen", cancelado: "Canceled" } },
    tarefas: {
      pendentes: "Pending tasks",
      concluidas: "Completed tasks",
      todas: "All tasks",
      vazio: "No tasks in this filter.",
    },
    tornarPrincipal: "Make {{nome}} the main contact",
    whatsapp: "Open in WhatsApp",
    produtos: {
      adicionar: "Add product or service",
      editarTitulo: "Edit product or service",
      vazio: "There are no products or services in this deal.",
      acoes: "Actions",
      colunas: {
        nome: "Name and recurrence",
        quantidade: "Quantity",
        preco: "Price and discount",
        subtotal: "Subtotal",
      },
      descontoPct: "Discount: {{pct}}% ({{valor}})",
      descontoValor: "Discount: {{valor}}",
      editar: "Edit {{nome}}",
      remover: "Remove {{nome}}",
      confirmarRemover: "Remove the product from the deal?",
      unico: "One-time value",
      recorrente: "Recurring value",
      total: "Total value",
      adicionado: "Product added",
      adicionadoOutro: "Product added. Choose the next one.",
      criarEOutro: "Create and add another",
      verticalDoProduto: "Product business unit",
      verticalTodas: "All",
      atualizado: "Product updated",
      passo1: "1. Choose product",
      passo2: "2. Set up product",
      catalogo: "Product or service from the catalog",
      avancar: "Next",
      voltar: "Back",
      adicionarBotao: "Add product",
      precoBase: "Base price: {{valor}}",
      valor: "Unit value",
      acrescentarDesconto: "Add discount",
      escolhaVertical: "Choose the business unit",
      escolhaVerticalPrimeiro: "Choose the business unit to see the services offered in it.",
      verticalNova: "{{nome}} (new to the deal)",
      verticalNovaAjuda: "This business unit is not on the deal yet; saving the item adds it to the deal as well.",
      servicoForaDaVertical: "The service \"{{nome}}\" is not offered in this business unit. Choose the service again.",
      tipoDesconto: "Discount type",
      tipos: {
        percentual: "% Percentage",
        valor: "{{simbolo}} Amount",
      },
      valorDesconto: "Discount value ({{unidade}})",
      equivalePct: "{{pct}}% = {{valor}} off",
      equivaleValor: "{{valor}} = {{pct}}% of the value",
      limites: {
        negativo: "The discount cannot be negative",
        percentualMaximo: "As a percentage, at most 100%",
        valorMaximo: "As an amount, at most {{maximo}} (value x quantity)",
      },
      resumoBruto: "Unit value x quantity",
      resumoDesconto: "Discount",
      resumoLiquido: "Product value in the deal",
      escolha: "Choose a product from the catalog",
      quantidadeInvalida: "Enter a quantity greater than zero",
    },
  },
  proposta: {
    criar: "Create proposal",
    nova: "New proposal",
    vazio:
      "Create and send proposals to the customer with the products of this deal.",
    semItens: "Add a product to the deal to create the proposal.",
    numero: "Proposal #{{numero}}",
    lista: {
      proposta: "Proposal",
      modelo: "Template",
      criada: "Created on",
      valor: "Value",
      status: "Status",
    },
    estados: {
      criada: "Created",
      enviada: "Sent",
      aceita: "Accepted",
      recusada: "Declined",
    },
    enviarEmail: "Send by email",
    imprimir: "Print",
    imprimirDeNovo: "Open the PDF again",
    mudarStatus: "Change the status of proposal #{{numero}}",
    excluir: "Delete proposal #{{numero}}",
    acoes: "Actions",
    excluirTitulo: "Delete proposal #{{numero}}?",
    excluirTexto:
      "The proposal leaves the deal and can be restored from the Trash for up to 30 days. A PDF already sent stays in Files.",
    excluida: "Proposal deleted",
    impressaAberta:
      "The proposal PDF (the same one sent by email) opened in another tab: print or save it there. If the tab did not open, use the button below.",
    criarImprimir: "Create and print",
    criarEmail: "Create and send by email",
    criada: "Proposal created",
    modelo: "Template",
    modeloPadrao: "{{nome}} (default)",
    previa: "Preview",
    campos: {
      titulo: "Title",
      apresentacao: "Introduction",
      condicoes: "General terms",
      rodape: "Footer",
    },
    colunas: {
      produto: "Product or service",
      quantidade: "Qty.",
      desconto: "Discount",
      preco: "Price",
      subtotal: "Subtotal",
    },
    semTitulo: "Sales proposal",
    aosCuidados: "Attn: {{contato}} | {{cliente}}",
    totalPedido: "Order total",
    itensTabela: "Proposal items",
    condicoes: "General terms",
  },
  email: {
    criar: "Create email",
    enviar: "Send email",
    enviado: "Email sent",
    vazio: "No emails sent from this deal.",
    para: "To",
    paraAjuda:
      "Only the email of the customer or of a contact person of the deal.",
    paraQuem: "To: {{para}}",
    assunto: "Subject",
    texto: "Message",
    semAcessoCadastros:
      "The customer and contact emails live in Records, which you cannot access. Ask whoever manages access.",
    semDestino: "The customer and the contact people have no email on record.",
    comProposta:
      "Proposal #{{numero}} as PDF ({{total}})",
    assuntoProposta: "Sales proposal #{{numero}} · {{titulo}}",
    ola: "Hello, {{nome}}!",
    olaSemNome: "Hello!",
    textoProposta:
      "{{saudacao}}\n\nPlease find the sales proposal attached. Let me know if you have any questions.\n\nBest regards,\n{{autor}}",
    // Lote crm4 (L8): anexos do "Criar e-mail" (arquivos da negociação).
    anexar: "Attach file",
    anexos: "Attachments",
    anexosAjuda: "Up to {{max}} files, {{limite}} in total ({{porArquivo}} per file): image, PDF, Word, Excel, PowerPoint, OpenDocument, TXT or CSV. The files also stay in the deal's Files tab.",
    anexosAjudaProposta: "The proposal goes as a PDF and counts toward the limit: {{max}} more files, up to {{limite}} in total, plus its PDF ({{porArquivo}} per file). Files also stay in the deal's Files tab.",
    removerAnexo: "Remove {{nome}}",
    anexoGrande: "{{nome}} is over the limit: attachments add up to {{limite}} at most.",
    anexoArquivoGrande: "{{nome}} is over the {{limite}} limit per file.",
    anexoTipo: "{{nome}} cannot go in the email: send an image, PDF, Word, Excel, PowerPoint, OpenDocument, TXT or CSV.",
    anexosDemais: "Attach up to {{max}} files.",
    enviandoAnexos: "Uploading the attachments",
  },
  questionarios: {
    vazio: "No questionnaires. Create them in CRM settings > Questionnaires.",
    escolher: "Questionnaire",
    respondido: "{{nome}} (answered)",
    salvar: "Save answers",
    salvo: "Answers saved",
    concluir: "Complete",
    salvarRascunho: "Save draft",
    rascunhoSalvo: "Draft saved",
    alteradoPor: "Last changed by {{nome}} on {{quando}}",
    excluirAplicacao: "Delete this questionnaire",
    confirmarExcluirAplicacao: "Delete this questionnaire from the deal?",
    confirmarExcluirAplicacaoTexto: "Its answers will no longer show. The other questionnaires are not affected.",
    excluido: "Questionnaire deleted",
    novo: "New questionnaire",
    nenhum: "No questionnaire in this deal yet. Pick a template and click New questionnaire.",
    escolherModelo: "Questionnaire template",
    iniciar: "Start",
    iniciado: "Questionnaire started",
    semModelos: "No active template. Create one in CRM Settings > Questionnaires.",
    lista: "Questionnaires of the deal",
    emAndamento: "In progress",
    concluido: "Completed",
    abrir: "Open {{nome}}",
    recolher: "Collapse {{nome}}",
    numero: "{{nome}} · no. {{n}}",
    iniciadoEm: "Started on {{quando}}",
    concluidoEm: "Completed on {{quando}}",
    pontosResumo: "{{count}} pt",
    resumoTotal_one: "{{count}} questionnaire",
    resumoTotal_other: "{{count}} questionnaires",
    sim: "Yes",
    nao: "No",
  },
  arquivos: {
    soltar: "Drag and drop the file here or click to choose",
    vazio: "No files in this deal.",
    enviados: "Files uploaded",
    baixar: "Download {{nome}}",
    excluir: "Delete {{nome}}",
    confirmarExcluir: "Delete the file?",
  },
  pausa: {
    tituloPausar: "Pause deal",
    tituloRetomar: "Resume deal",
    textoPausar: "Tell us why this deal is being paused. While it is paused, nothing in it can be changed. The reason is kept in the history.",
    textoRetomar: "Tell us why this deal is going back to work. The reason is kept in the history.",
    motivo: "Reason",
    erroMotivo: "Enter the reason, {{min}} to {{max}} characters.",
    confirmarPausar: "Pause",
    confirmarRetomar: "Resume",
    aviso: "Deal paused: resume it to be able to change it.",
    naoMove: "Deal paused: resume it before moving it to another stage.",
    naoEncerra: "Deal paused: resume it before marking a sale or a loss.",
  },
  playbook: {
    titulo: "Guidance by stage",
    ajuda:
      "What to do in each pipeline stage, and the items to check in this deal.",
    objetivo: "Stage goal",
    descricao: "Description",
    semObjetivo: "The stage goal has not been set up yet.",
    semDescricao: "The description has not been set up yet.",
    configurar: "Set up the playbook",
  },
};

export const cascaEs: typeof cascaPt = {
  comercial: "Comercial",
  atividades: "Actividades",
  configuracoes: "Configuración del CRM",
  central: "Central de archivos",
  relatorios: "Informes",
};

export const crmEs: DicCrm = {
  atividades: {
    titulo: "Actividades",
    criar: "Crear tarea",
    todasTarefas: "Todas las tareas",
    nResponsaveis_one: "{{count}} responsable",
    nResponsaveis_other: "{{count}} responsables",
    responsaveis: "Responsables",
    minhas: "Solo las mías",
    buscarResponsavel: "Buscar responsable",
    qualquerPeriodo: "Cualquier período",
    periodo: "Período",
    periodos: {
      hoje: "Hoy",
      semana: "Esta semana",
      mes: "Este mes",
      "7": "Últimos 7 días",
      "14": "Últimos 14 días",
      "30": "Últimos 30 días",
      "180": "Últimos 6 meses",
      personalizado: "Período personalizado",
    },
    de: "Desde",
    ate: "Hasta",
    todosTipos: "Todos los tipos de tareas",
    nTipos_one: "{{count}} tipo de tarea",
    nTipos_other: "{{count}} tipos de tareas",
    situacao: "Estado",
    situacoes: {
      atrasadas: "Atrasadas",
      pendentes: "Pendientes",
      concluidas: "Completadas",
      todas: "Todos los estados",
    },
    limparFiltros: "Limpiar filtros",
    resumoSemana: "Resumen de las tareas de la semana",
    diasDaSemana: "Del {{de}} al {{ate}}",
    funil: "Embudo",
    todosFunis: "Todos los embudos",
    criadas: "Creadas",
    concluidas: "Completadas",
    abertasEmDia: "Abiertas al día",
    atrasadas: "Atrasadas",
    colunas: {
      tarefa: "Tareas",
      status: "Estado",
      dataHora: "Fecha y hora",
      responsaveis: "Responsables",
      negociacao: "Negociación",
      valor: "Valor total",
    },
    status: {
      atrasada: "Atrasada",
      hoje: "Para hoy",
      futura: "Agendada",
      concluida: "Completada",
      cancelada: "Cancelada",
    },
    selecionar: "Seleccionar {{nome}}",
    selecionarPagina: "Seleccionar las tareas de la página",
    selecionados_one: "{{count}} seleccionada",
    selecionados_other: "{{count}} seleccionadas",
    limparSelecao: "Limpiar selección",
    selecionarTodos: "Seleccionar los {{count}} elementos de este filtro",
    selecionarTodosLimite:
      "Seleccionar los primeros {{limite}} de {{count}} elementos de este filtro",
    acoesMassa: "Acciones con las seleccionadas",
    adiar: "Posponer tarea",
    adiarModos: {
      hora1: "En 1 hora",
      hora2: "En 2 horas",
      amanha: "Para mañana",
      dias2: "En 2 días",
      semana: "Para la próxima semana",
      mes: "Para el próximo mes",
    },
    exportar: "Exportar",
    transferir: "Transferir tarea",
    atribuir: "Asignar responsable",
    concluir: "Marcar como completada",
    escolherResponsavel: "Elige el responsable",
    confirmarLote_one: "¿Aplicar a {{count}} tarea?",
    confirmarLote_other: "¿Aplicar a {{count}} tareas?",
    confirmarTransferir: "{{nome}} pasa a ser el único responsable.",
    confirmarAtribuir: "{{nome}} entra como un responsable más.",
    resultado: "{{alterados}} cambiadas; {{ignorados}} sin cambios",
    exportado: "Exportación lista",
    arquivoCsv: "tareas.csv",
    sobre: "Sobre la negociación",
    vazio: "No se encontraron tareas.",
    reuniaoNaAgenda: "Reunión agendada en la Agenda",
    editar: "Editar tarea",
    verAta: "Ver el acta",
    ataArquivos: "Archivos adjuntos",
    ataArquivosFora_one: "{{count}} archivo ya no está en la negociación.",
    ataArquivosFora_other: "{{count}} archivos ya no están en la negociación.",
    ata: "Acta de la tarea",
    concluidaEm: "Completada el {{data}}",
    abrirNegociacao: "Abrir la negociación",
    sobreNegociacao: "Sobre la negociación",
    editarTarefa: "Editar la tarea {{titulo}}",
    filtrosLigados: "Filtros activos",
    filtrosN: "Filtros ({{n}})",
    filtrosTitulo: "Filtros",
    aplicarFiltros: "Aplicar filtros",
    periodoAgendamento: "Período de programación",
    tirarFiltro: "Quitar el filtro {{filtro}}",
    verRelatorio: "Ver informe completo",
    configurar: "Workflows comerciales",
  },
  form: {
    criarTitulo: "Crear tarea",
    editarTitulo: "Editar tarea",
    proximaTitulo: "Crear próxima tarea",
    empresa: "Empresa de la negociación",
    negociacao: "Negociación",
    selecionar: "Seleccionar",
    criarNegociacao: "Crear negociación para esta tarea",
    assunto: "Asunto de la tarea",
    descricao: "Descripción de la tarea",
    responsaveis: "Responsables",
    principal: "principal",
    tipo: "Tipo de tarea",
    dataHora: "Fecha y hora",
    concluirAoCriar: "Marcar como completada al crear",
    dica: "Crea tareas automáticamente: los workflows comerciales sugieren la próxima tarea al completar una.",
    conhecerWorkflows: "Conocer los workflows comerciales",
    semResponsavel: "Elige al menos un responsable",
    obrigatorio: "Campo obligatorio",
    selecioneNegociacao: "Selecciona la negociación",
    criada: "Tarea creada",
    criadaComMeet: "Tarea creada. El enlace de Google Meet aparece en la reunión en unos instantes.",
    descricaoLonga: "La descripción de la reunión admite hasta {{max}} caracteres.",
    atualizada: "Tarea actualizada",
    cancelarTarefa: "Cancelar tarea",
    confirmarCancelar: "¿Cancelar esta tarea?",
    confirmarCancelarTexto:
      "Sale de las pendientes y queda en el historial de la negociación como cancelada.",
    cancelada: "Tarea cancelada",
    excluir: "Eliminar",
    excluida: "Tarea eliminada",
    confirmarExcluir: "Eliminar tarea",
    confirmarExcluirTexto: "La tarea se eliminará y saldrá de las listas y del historial de tareas. Esta acción no se puede deshacer.",
    adicionarResponsavel: "Agregar responsable",
    removerResponsavel: "Quitar a {{nome}}",
    justificativa: "Justificación",
    justificativaAjuda: "Queda en el historial de la negociación (de 10 a 500 caracteres).",
    reabrirTitulo: "Reabrir tarea",
    reabrir: "Reabrir",
    reaberta: "Tarea reabierta",
    reabrirDica: "La tarea cancelada vuelve a pendiente cuando guardes. Cambia lo que haga falta.",
    data: "Fecha de la cita",
    horario: "Hora de la tarea",
    reuniaoAgenda:
      "Reunión agendada en la Agenda: la hora se cambia en la Agenda.",
    descricaoConvidados: "Los invitados reciben esta descripción.",
    agendarNaAgenda: "Agendar en la Agenda y en Google",
    agendarNaAgendaAjuda:
      "Desmárcala para solo registrar la actividad (reunión ya realizada o agendada por fuera).",
    servico: "Servicio",
    recurso: "Recurso (la agenda de quien atiende)",
    escolhaHorario: "Elige un horario libre.",
  },
  atalho: {
    titulo: "Tareas y reuniones",
    verHoje: "Ver hoy",
    semana: "Semana",
    semanaAnterior: "Semana anterior",
    proximaSemana: "Próxima semana",
    todas: "Mostrar las tareas y reuniones de todos",
    carregando: "Cargando...",
    vazioTitulo: "Ninguna tarea ni reunión pendiente",
    vazioTexto: "Prueba seleccionar otra fecha o usa el botón de abajo para ver todas tus tareas.",
    irTarefas: "Ir a la página de tareas",
    abrirReuniao: "Abrir la reunión en la Agenda",
    semTarefa: "Ver negociaciones sin tarea",
  },
  semNegociacao: {
    titulo: "Esta tarea necesita una negociación",
    texto:
      "Toda tarea queda ligada a una negociación. Puedes elegir una existente o crear la negociación ahora.",
    guardado:
      "Lo que ya escribiste en la tarea queda guardado y vuelve completado.",
    escolher: "Elegir una existente",
    criar: "Crear negociación",
  },
  negociacaoTarefa: {
    titulo: "Crear negociación para la tarea",
    aviso:
      "La tarea que estabas creando quedó guardada. Al crear la negociación, vuelve completada y ya ligada a ella.",
    criarVoltar: "Crear y volver a la tarea",
    voltar: "Volver a la tarea",
  },
  concluir: {
    titulo: "Completar tarea",
    tituloVarias_one: "Completar {{count}} tarea",
    tituloVarias_other: "Completar {{count}} tareas",
    intro:
      "Para completar, registra el acta o el resumen de lo que se hizo. Usa un ejemplo o inserta lo que el CRM ya sabe de la negociación; los adjuntos son opcionales. Todo va al historial de la negociación.",
    mesmaAta: "La misma acta y los mismos archivos valen para todas.",
    exemplos: "Ejemplos de acta",
    ata: "Acta / resumen de lo que se hizo",
    ataAjuda:
      "Haz clic en un ejemplo para empezar; los tramos [ ] son para que los completes (Tab salta al siguiente).",
    ataPlaceholder: "Lo que se conversó, se decidió y el próximo paso acordado",
    inserir: "Insertar del sistema",
    inserirAjuda: "(entra donde está el cursor)",
    arquivos: "Archivos",
    opcional: "(opcional)",
    naNegociacao: "Documentos que ya están en la negociación",
    grupoArquivos: "Archivos de la negociación",
    anexarNovo: "Adjuntar archivo nuevo",
    removerArquivo: "Quitar {{nome}}",
    botao: "Completar tarea",
    botaoVarias: "Completar tareas",
    concluida: "Tarea completada con el acta",
    concluidas: "Tareas completadas con el acta",
    erroCurta: "Escribe el acta o el resumen (al menos 10 caracteres)",
    erroLacuna:
      "Completa los tramos [ ] del ejemplo (o borra los que no se aplican)",
  },
  inserir: {
    negociacao: "Negociación",
    empresa: "Empresa",
    contato: "Contacto",
    produtos: "Productos",
    ultimaAnotacao: "Última nota",
    ataAnterior: "Acta anterior",
    proximaReuniao: "Próxima reunión",
    negociacaoTxt: "Negociación {{nome}} · etapa {{etapa}} · valor {{valor}}",
    empresaTxt: "Empresa: {{nome}}",
    contatoTxt: "Contacto: {{nome}}{{extra}}",
    produtosTxt: "Productos: {{lista}}",
    anotacaoTxt: "Nota del {{data}}: {{texto}}",
    ataAnteriorTxt: 'En la tarea anterior ("{{titulo}}"): {{ata}}',
    reuniaoTxt: 'Próxima reunión: "{{titulo}}" el {{data}}',
    ultimaProposta: "Última propuesta",
    ultimoEmail: "Último correo",
    propostaTxt: "Propuesta #{{numero}} ({{estado}}) del {{data}} · valor {{valor}}{{para}}",
    enviadaPara: " · enviada a {{email}}",
    emailTxt: 'Correo del {{data}}{{para}}: "{{assunto}}" · {{texto}}',
    paraEmail: " para {{email}}",
  },
  ata: {
    ocliente: "el cliente",
    aempresa: "la empresa",
    noTelefone: " al {{fone}}",
    hojeEm: " (hoy en {{etapa}})",
    modeloDe: "Modelo de {{tipo}}",
    modelos: {
      tarefa:
        'Tarea "{{titulo}}" completada. Resultado: [ ]. Próximo paso: [ ].',
      ligacao:
        'Llamé a {{quem}} ({{emp}}){{fone}}. Hablamos sobre "{{titulo}}". Quedó acordado: [ ]. Próximo paso: [ ].',
      reuniao:
        "Reunión con {{quem}} de {{emp}} el {{data}}. Temario: {{titulo}}. Decisiones: [ ]. Pendientes del cliente: [ ]. Próximo paso: [ ].",
      email:
        'Correo enviado a {{quem}}{{mail}} sobre "{{titulo}}". Esperando respuesta hasta [ ].',
      whatsapp:
        'Mensaje enviado a {{quem}} por WhatsApp{{fone}} sobre "{{titulo}}". Respuesta del cliente: [ ].',
      visita:
        "Visita a {{emp}}, recibido por {{quem}}. Lo que vimos: [ ]. Acordado: [ ]. Próximo paso: [ ].",
      almoco: "Almuerzo con {{quem}} ({{emp}}). Temas: [ ]. Acordado: [ ].",
    },
    situacoes: {
      avancou: "Avanzó",
      semRetorno: "Sin respuesta",
      pediuProposta: "Pidió propuesta",
      feito: "Hecho como se acordó",
    },
    textos: {
      avancou:
        "{{quem}} aprobó el próximo paso: [ ]. La negociación{{etapa}} sigue a [ ].",
      semRetorno:
        "Intenté contactar a {{quem}} y no tuve respuesta. Nuevo intento el [ ].",
      pediuProposta: "{{quem}} pidió la propuesta con [ ]. Enviar hasta [ ].",
      feito: "Tarea completada como se acordó. Resultado: [ ].",
      semRetornoMassa:
        "Intenté contactar y no tuve respuesta. Nuevo intento el [ ].",
    },
  },
  proxima: {
    anteriores: "Resumen de las tareas anteriores",
    semAnteriores: "Ninguna tarea se completó antes en esta negociación.",
    sugestoes: "Sugerencias de próxima tarea",
    sugestoesAjuda:
      "Por los workflows comerciales y por lo que se escribió en el acta. Haz clic para usar; puedes editar todo abajo.",
    emDias_one: "en {{count}} día",
    emDias_other: "en {{count}} días",
    motivoWorkflow: 'Workflow "{{nome}}", paso {{passo}}',
    motivoAta: "Por el resumen: habla de {{palavra}}",
    motivoPadrao: "Sugerencia estándar",
    configurar: "Configurar workflows",
    descricaoPadrao: 'Próximo paso después de "{{titulo}}".',
  },
  pistas: {
    proposta: "Enviar propuesta comercial",
    contrato: "Enviar contrato para firma",
    reuniao: "Reunión de presentación",
    documentos: "Cobrar documentos pendientes",
    retorno: "Llamada de retorno",
    whatsapp: "Mensaje de seguimiento",
    padrao: "Seguimiento",
    palavra: {
      proposta: "propuesta",
      contrato: "contrato",
      reuniao: "reunión",
      documentos: "documentos",
      retorno: "retorno",
      whatsapp: "WhatsApp",
    },
  },
  workflows: {
    titulo: "Workflows comerciales",
    intro1:
      'Crea todos los workflows que necesites, cada uno con su proceso (venta consultiva, renovación, posventa...). Cada workflow tiene pasos: cuando alguien completa una tarea, el CRM abre "Crear próxima tarea" con el resumen de las tareas anteriores y las sugerencias de los workflows activos.',
    intro2:
      "Las sugerencias también vienen de lo que se escribió en el acta (por ejemplo, si el acta habla de propuesta, sugiere enviar la propuesta).",
    abrirProxima: 'Abrir "Crear próxima tarea" al completar una tarea',
    n_one: "{{count}} workflow",
    n_other: "{{count}} workflows",
    criar: "Crear workflow",
    editar: "Editar",
    duplicar: "Duplicar",
    excluir: "Eliminar",
    confirmarExcluir: '¿Eliminar "{{nome}}"?',
    confirmarExcluirTexto_one:
      "El workflow y su paso se eliminan. Las tareas ya creadas no cambian.",
    confirmarExcluirTexto_other:
      "El workflow y sus {{count}} pasos se eliminan. Las tareas ya creadas no cambian.",
    vazio:
      "Ningún workflow. Las sugerencias vienen solo del acta hasta que crees uno.",
    usarExemplos: "Crear los ejemplos",
    todosFunis: "Todos los embudos",
    passos_one: "{{count}} paso",
    passos_other: "{{count}} pasos",
    desligadoSelo: "apagado",
    ligar: "Encender el workflow {{nome}}",
    ligado: "Workflow encendido",
    desligado: "Workflow apagado",
    criado: "Workflow creado",
    atualizado: "Workflow actualizado",
    duplicado: "Workflow duplicado",
    excluido: "Workflow eliminado",
    salvo: "Configuración guardada",
    copia: "{{nome}} (copia)",
    nome: "Nombre del workflow",
    nomePlaceholder: "Ej.: Venta consultiva, Renovación, Posventa",
    valePara: "Vale para",
    passos: "Pasos",
    passo: "Paso {{n}}",
    removerPasso: "Quitar el paso {{n}}",
    quando: "Al completar",
    qualquer: "Cualquier tarea",
    etapa: "En la etapa",
    qualquerEtapa: "Cualquier etapa",
    sugerir: "Sugerir",
    assunto: "Asunto",
    assuntoPlaceholder: "Ej.: Enviar propuesta comercial",
    dias: "En (días)",
    adicionarPasso: "Agregar paso",
    passoSemAssunto: "Paso {{n}}: indica el asunto de la tarea sugerida",
    previa:
      "Al completar {{quando}}{{etapa}} → sugerir {{tipo}} · {{assunto}} {{dias}}",
    previaQualquer: "cualquier tarea",
    previaEtapa: " en la etapa {{etapa}}",
    exemplos: {
      vendaConsultiva: "Venta consultiva",
      posVenda: "Posventa y relación",
      diagnostico: "Reunión de diagnóstico",
      proposta: "Enviar propuesta comercial",
      acompanhamento: "Llamada de seguimiento de la propuesta",
      agradecer: "Agradecer la visita",
      resumo: "Enviar el resumen de lo acordado",
    },
  },
  configuracoes: {
    titulo: "Configuración del CRM",
    secoes: {
      funis: "Embudos de ventas",
      campos: "Configurar campos",
      motivos: "Motivo de pérdida",
      fontes: "Fuentes y campañas",
      qualificacao: "Calificación",
      questionarios: "Cuestionarios",
      modelos: "Plantillas de propuesta",
      workflows: "Workflows comerciales",
      "status-proposta": "Estados de propuesta",
    },
    salvo: "Configuración guardada",
    salvar: "Guardar",
    statusProposta: {
      intro: "Los estados que aparecen en el menú de cada propuesta. Cada estado sigue un estado base (creada, enviada, aceptada o rechazada), que es lo que usan las reglas del CRM.",
      criar: "Crear estado",
      editar: "Editar estado",
      nome: "Nombre del estado",
      cor: "Color",
      estadoBase: "Estado base",
      estadoBaseAjuda: "Las reglas del CRM leen el estado base: al enviar la propuesta, por ejemplo, la creada pasa al estado de \"enviada\".",
      estadoBaseTravado: "El estado base de los estados de fábrica y de los que están en uso no cambia.",
      ativo: "Activo",
      inativo: "Inactivo",
      fabrica: "De fábrica",
      emUso_one: "{{count}} propuesta",
      emUso_other: "{{count}} propuestas",
      subir: "Subir {{nome}}",
      descer: "Bajar {{nome}}",
      ativar: "Activar {{nome}}",
      desativar: "Desactivar {{nome}}",
      editarNome: "Editar {{nome}}",
      emUsoAviso: "Para desactivarlo, cambia antes las propuestas de este estado a otro.",
      cores: { neutro: "Gris", acento: "Verde Malgo", roxo: "Morado", azul: "Azul", ciano: "Cian", laranja: "Naranja", dourado: "Amarillo", verde: "Verde", perigo: "Rojo" },
    },
    funis: {
      intro: "Los embudos y las etapas por las que pasan las negociaciones. En cada etapa abierta, el playbook indica el objetivo y los ítems a revisar.",
      gerir: "Crear y organizar embudos",
      adicionarEtapa: "Agregar etapa",
      probabilidade: "{{n}}% de probabilidad",
      comPlaybook: "Con playbook",
      configurarEtapa: "Configurar etapa",
      excluirEtapa: "Eliminar la etapa {{nome}}",
      subirEtapa: "Llevar la etapa {{nome}} antes",
      descerEtapa: "Llevar la etapa {{nome}} después",
      confirmarExcluir: "¿Eliminar la etapa {{nome}}?",
      confirmarExcluirTexto: "Solo se puede eliminar una etapa sin negociaciones. El embudo debe mantener una etapa abierta, una ganada y una perdida.",
      probabilidadeInvalida: "Usa un número entero de 0 a 100",
      nomeEtapa: "Nombre de la etapa",
      itensPlaybook: "Ítems a revisar",
      itemN: "Ítem {{n}}",
      removerItem: "Quitar el ítem {{n}}",
      adicionarItem: "Agregar ítem",
    },
    campos: {
      intro: "Los campos personalizados de las negociaciones están en la pantalla de campos del sistema, junto con los de otros módulos.",
      abrir: "Abrir los campos personalizados",
      ajuda: "Elige la entidad Oportunidad para ver y crear los campos comerciales.",
    },
    fontes: {
      ajuda: "Las fuentes y campañas aparecen como opciones en la ficha de la negociación y en los filtros del Comercial.",
      fontes: "Fuentes",
      campanhas: "Campañas",
      livres: {
        fontes: "Permitir escribir una fuente fuera de la lista",
        campanhas: "Permitir escribir una campaña fuera de la lista",
      },
      vazio: "Ningún ítem registrado.",
      excluir: "Eliminar {{nome}}",
      nome: {
        fontes: "Nueva fuente",
        campanhas: "Nueva campaña",
      },
      descricao: "Descripción",
      adicionar: "Agregar",
    },
    qualificacao: {
      semNome: "Da un nombre a cada nivel",
      intro: "La calificación va de 1 a 5 estrellas. Da un nombre a cada nivel; aparece al pasar el mouse por las estrellas.",
      nivel: "Nombre del nivel {{n}}",
      ajuda: "Las negociaciones ya calificadas mantienen sus estrellas; solo cambia el nombre.",
    },
    questionarios: {
      intro: "Preguntas que el vendedor responde en la ficha de la negociación, en la pestaña Cuestionarios.",
      criar: "Crear cuestionario",
      editar: "Editar cuestionario",
      vazio: "Ningún cuestionario todavía.",
      ligar: "Usar el cuestionario {{nome}}",
      perguntas_one: "{{count}} pregunta",
      perguntas_other: "{{count}} preguntas",
      confirmarExcluir: "¿Eliminar el cuestionario {{nome}}?",
      confirmarExcluirTexto: "Las respuestas ya dadas en las negociaciones dejan de mostrarse.",
      semOpcoes: "Indica al menos una opción",
      nome: "Nombre del cuestionario",
      pergunta: "Pregunta {{n}}",
      removerPergunta: "Quitar la pregunta {{n}}",
      texto: "Pregunta",
      tipo: "Tipo de respuesta",
      tipos: {
        texto: "Texto",
        sim_nao: "Sí o no",
        opcoes: "Lista de opciones",
        numero: "Número",
      },
      obrigatoria: "Respuesta obligatoria",
      opcoes: "Opciones",
      opcoesAjuda: "Una opción por línea.",
      adicionarPergunta: "Agregar pregunta",
    },
    modelos: {
      intro: "Las plantillas definen el color y los textos iniciales de las propuestas. La plantilla predeterminada viene elegida al crear una propuesta.",
      criar: "Crear plantilla",
      editar: "Editar plantilla",
      rascunho: "Borrador",
      tornarPadrao: "Hacer predeterminada",
      confirmarExcluir: "¿Eliminar la plantilla {{nome}}?",
      confirmarExcluirTexto: "Las propuestas ya creadas con ella quedan como están.",
      nome: "Nombre de la plantilla",
      cor: "Color",
      publicado: "Disponible para los vendedores",
    },
    semPermissao: "Solo quien edita el comercial cambia esta configuración.",
  },
  comercial: {
    titulo: "Pipeline",
    subtitulo: "Tus ventas en curso, etapa por etapa",
    visao: "Vista",
    visoes: {
      funil: "Embudo",
      lista: "Lista",
    },
    estatisticasEtapas: "Estadísticas de las etapas",
    sobre: "Sobre la negociación",
    sobreDe: "Sobre la negociación {{nome}}",
    recarregar: "Recargar",
    recarregado: "Recargado",
    recarregarEtapa: "Recargar etapa",
    recarregarEtapaDe: "Recargar la etapa {{etapa}}",
    etapaRecarregada: "Etapa recargada",
    configurarFunil: "Configurar embudo",
    avanco: "Avance en el embudo",
    avancoAjuda: "Posición de esta etapa entre las etapas abiertas del embudo: cuánto del camino ha recorrido la negociación al llegar aquí",
    adicionarValor: "Agregar valor",
    maisOpcoes: "Más opciones",
    configurarFunis: "Configurar embudos",
    personalizarCartoes: "Personalizar tarjetas",
    criar: "Crear",
    criarNegociacao: "Crear negociación",
    todasNegociacoes: "Todas las negociaciones",
    minhasNegociacoes: "Mis negociaciones",
    etapa: "Etapa del embudo",
    todasEtapas: "Todas las etapas",
    status: "Estado de la negociación",
    statusFiltro: {
      todos: "Todos los estados",
      andamento: "En curso",
      vendido: "Vendido",
      perdido: "Perdido",
      pausado: "Pausado",
      nao_pausado: "No pausado",
    },
    ordenacao: "Ordenar",
    ordens: {
      az: "Alfabético A-Z",
      za: "Alfabético Z-A",
      criadas_ultimo: "Creadas al final",
      criadas_primeiro: "Creadas primero",
      proxima_tarefa: "Fecha de la próxima tarea",
      previsao: "Previsión de cierre",
      contato_recente: "Contacto más reciente",
      contato_antigo: "Contacto más antiguo",
      mais_qualificadas: "Más calificadas",
      menos_qualificadas: "Menos calificadas",
      maior_valor: "Mayor valor total",
      menor_valor: "Menor valor total",
      interacao_recente: "Interacción más reciente",
      interacao_antiga: "Interacción más antigua",
    },
    filtrosN: "Filtros ({{n}})",
    filtrosLigados: "Filtros activos",
    nNegociacoes_one: "{{count}} negociación",
    nNegociacoes_other: "{{count}} negociaciones",
    tirarFiltro: "Quitar el filtro {{filtro}}",
    estatisticaEtiqueta: "Estadística de la etapa: {{nome}}",
    moverSoAbertas: "Para vender o perder, usa las acciones de la negociación",
    cartoesSalvos: "Tarjetas actualizadas",
    cartoesAjuda:
      "Elige los campos que aparecen en la tarjeta de la negociación en el embudo. Vale para todo el workspace.",
    camposCartao: {
      empresa: "Empresa / contacto",
      qualificacao: "Calificación",
      responsavel: "Responsable",
      valor: "Valor total",
      proxima_tarefa: "Próxima tarea",
      criada_em: "Fecha de creación",
      fonte: "Fuente",
      previsao: "Previsión de cierre",
      vertical: "Vertical",
      regime: "Régimen tributario previsto",
    },
    statusNeg: {
      andamento: "En curso",
      vendido: "Vendida",
      perdido: "Perdida",
      pausado: "Pausada",
    },
    semTarefas: "Sin tareas",
    criadaEm: "Creada el {{data}}",
    fonteCartao: "Fuente: {{fonte}}",
    previsaoCartao: "Previsión: {{data}}",
    regimeCartao: "Régimen: {{regime}}",
    estrelas_one: "{{count}} estrella",
    estrelas_other: "{{count}} estrellas",
    qualificacao: "Calificación",
    estatisticas: {
      andamento: "En curso",
      sem_tarefa: "Sin tareas",
      atrasadas: "Con tareas atrasadas",
      sem_produtos: "Sin productos o servicios",
    },
    mostrarEstatisticas: "Mostrar las estadísticas de {{etapa}}",
    esconderEstatisticas: "Ocultar las estadísticas de {{etapa}}",
    conversao: "Conversión de la etapa",
    conversaoAjuda:
      "De las {{entraram}} negociaciones del embudo que llegaron a esta etapa, {{avancaram}} avanzaron a una etapa siguiente o se vendieron",
    conversaoDe: "({{avancaram}} de {{entraram}})",
    mostrandoDe:
      "Mostrando {{n}} de {{total}}: usa los filtros o la lista para ver el resto",
    resultado: "{{alterados}} cambiadas; {{ignorados}} sin cambios",
    exportCab: [
      "Nombre",
      "Empresa",
      "Etapa",
      "Estado",
      "Responsable",
      "Calificación",
      "Fuente",
      "Campaña",
      "Valor único",
      "Valor recurrente",
      "Creada el",
      "Previsión",
    ],
    arquivoCsv: "negociaciones.csv",
    exportadas_one: "{{count}} negociación exportada",
    exportadas_other: "{{count}} negociaciones exportadas",
    selecionadas_one: "{{count}} seleccionada",
    selecionadas_other: "{{count}} seleccionadas",
    selecionarPagina: "Seleccionar las negociaciones de la página",
    colunas: {
      negociacao: "Negociaciones",
      responsavel: "Responsable",
      qualificacao: "Calificación",
      etapa: "Etapa del embudo",
      valor: "Valor total",
      criacao: "Fecha de creación",
      status: "Estado",
    },
    unico: "Único: {{valor}}",
    recorrente: "Recurrente: {{valor}}",
    vazio: "No se encontraron negociaciones.",
    exibindo: "Mostrando",
    porPagina: "Negociaciones por página",
    deTotal: "de {{total}}",
    anterior: "Anterior",
    proxima: "Siguiente",
    lote: {
      transferir: "Transferir",
      status: "Cambiar estado",
      campo: "Agregar o cambiar",
      tarefa: "Crear tarea",
      mover: "Mover",
      excluir: "Eliminar",
      transferirTitulo: "¿Transferir las negociaciones?",
      transferirTexto: "Estás transfiriendo {{n}} a {{nome}}.",
      perguntaTransferir: "¿Cuántas negociaciones se transferirán?",
      transferirBotao: "Transferir negociaciones",
      statusTitulo: "¿Cambiar el estado de las negociaciones?",
      statusTexto: "Estás cambiando el estado de {{n}} a {{status}}.",
      perguntaAlterar: "¿Cuántas negociaciones se cambiarán?",
      statusBotao: "Cambiar estado",
      campoTitulo: "Agregar o cambiar {{campo}}",
      campoTexto: "Estás cambiando {{campo}} de {{n}}.",
      campoBotao: "Agregar o cambiar",
      produtoTexto: "Estás agregando un producto o servicio a {{n}}.",
      tarefaTitulo: "Crear tarea para las negociaciones seleccionadas",
      tarefaTexto:
        "Una tarea en cada una de las {{n}}, con el responsable de cada negociación.",
      perguntaCriar: "¿Para cuántas negociaciones?",
      tarefaBotao: "Crear tareas",
      moverTitulo: "Mover negociaciones",
      moverTexto: "Estás moviendo {{n}} a otra etapa del embudo.",
      moverBotao: "Mover negociaciones",
      excluirTitulo: "Eliminar negociaciones",
      excluirTexto:
        "Estás eliminando {{n}}, con sus tareas. Quedan 30 días en la papelera.",
      perguntaExcluir: "¿Cuántas negociaciones se eliminarán?",
      excluirBotao: "Eliminar negociaciones",
    },
  },
  sobre: {
    etapa: "Etapa",
    hoje: "Entró hoy",
    haDias_one: "{{count}} día en esta etapa",
    haDias_other: "{{count}} días en esta etapa",
    funil: "Embudo",
    responsavel: "Responsable",
    semResponsavel: "Sin responsable",
    empresa: "Empresa",
    contatoPrincipal: "Contacto principal",
    semContato: "Sin contacto",
    vertical: "Vertical",
    produtos: "Productos",
    semProdutos: "Ningún producto",
    maisN: "+{{count}}",
    origem: "Origen",
    atividades: "Actividades",
    nPendentes_one: "{{count}} pendiente",
    nPendentes_other: "{{count}} pendientes",
    nAtrasadas_one: "{{count}} atrasada",
    nAtrasadas_other: "{{count}} atrasadas",
    ultimaAtividade: "Última: {{tipo}} · {{titulo}} el {{quando}}",
    semUltimaAtividade: "Ninguna actividad concluida",
    questionarios: "Cuestionarios",
    nEmAndamento_one: "{{count}} en curso",
    nEmAndamento_other: "{{count}} en curso",
    nConcluidos_one: "{{count}} concluido",
    nConcluidos_other: "{{count}} concluidos",
    semQuestionarios: "Ningún cuestionario",
    propostas: "Propuestas",
    propostaN: "Propuesta n.º {{n}}",
    semPropostas: "Ninguna propuesta",
    camposPersonalizados: "Campos personalizados",
    dadosGerais: "Datos generales",
    fonte: "Fuente",
    campanha: "Campaña",
    interacoes: "Interacciones",
    nInteracoes_one: "{{count}} interacción",
    nInteracoes_other: "{{count}} interacciones",
    ultimaAnotacao: "Última nota",
    semAnotacao: "No se hizo ninguna nota para esta negociación",
    criacao: "Fecha de creación",
    ultimoContato: "Último contacto",
    previsao: "Previsión de cierre",
    identificador: "Identificador",
    naoPreenchido: "Sin completar",
    semCampanha: "Sin campaña",
    abrir: "Abrir negociación",
  },
  criarNeg: {
    nome: "Nombre de la negociación",
    nomePlaceholder: "Escribe el nombre de la negociación",
    fonte: "Fuente",
    campanha: "Campaña",
    funil: "Embudo de ventas",
    etapa: "Etapa del embudo de ventas",
    etapaAjuda: "Sin elegir, la primera etapa del embudo.",
    responsavel: "Responsable",
    grupoEmpresa: "Información de la empresa",
    empresa: "Empresa de la negociación",
    adicionarEmpresa: "Agregar empresa",
    grupoContato: "Información del contacto",
    contato: "Contacto",
    criarContato: "Crear contacto",
    dicaCartoes: "Elige los campos que aparecen en la tarjeta de la negociación en el embudo, en Más opciones > Personalizar tarjetas.",
    salvarOutra: "Guardar y crear otra",
    criar: "Crear",
    criada: "Negociación creada",
    criadas_one: "{{count}} negociación creada",
    criadas_other: "{{count}} negociaciones creadas",
    semCliente: "Elige la empresa o el contacto de la negociación.",
    parcial: "{{feitos}} de {{total}} negociaciones creadas. Las creadas salieron de la lista; envía de nuevo para crear las que faltan.",
    contatoNaoEntrou: "La negociación se creó, pero el contacto no entró en ella. Agrégalo desde la ficha.",
    contatosDaEmpresa: "Contactos de la empresa",
    contatosDaEmpresaAjuda: "Los marcados entran en la negociación junto con el contacto elegido.",
    // Lista de 03/11, item 3: várias empresas e vários contatos na criação.
    empresaPrincipalAjuda: "La primera empresa es la principal: es el cliente de la negociación en los informes y en la facturación.",
    selePrincipal: "Principal",
    empresasDoGrupo: "Empresas del mismo grupo",
    empresasDoGrupoAjuda: "La casa matriz y las sucursales de esta empresa. Las marcadas entran como empresas adicionales; la elegida sigue como principal.",
    empresasDoGrupoTruncado: "Se muestran las primeras 100 del grupo. Para otra, búscala en Otras empresas.",
    empresasDoGrupoLimite: "Hasta {{n}} empresas adicionales por negociación.",
    empresasDoGrupoErro: "No se pudieron cargar las empresas del grupo. Puedes buscarlas en Otras empresas.",
    outrasEmpresas: "Otras empresas",
    outrasEmpresasAjuda: "Entran en la negociación como empresas adicionales, debajo de la principal.",
    buscarOutraEmpresa: "Agregar otra empresa",
    criarOutraEmpresa: "Crear otra empresa",
    outrosContatos: "Otros contactos",
    outrosContatosAjuda: "Entran en la negociación junto con el contacto principal.",
    buscarOutroContato: "Agregar otro contacto",
    criarOutroContato: "Crear otro contacto",
    tirarDaLista: "Quitar a {{nome}} de la lista",
    empresaNaoEntrou: "La negociación se creó, pero alguna empresa adicional no entró en ella. Agrégala desde la ficha.",
  },
  filtros: {
    titulo: "Filtros",
    limpar: "Limpiar filtros",
    aplicar: "Aplicar filtros",
    salvos: "Filtros guardados",
    escolherSalvo: "Elegir un filtro guardado",
    renomear: "Renombrar filtro",
    excluir: "Eliminar filtro",
    salvarAtual: "Guardar estos filtros",
    gravar: "Guardar",
    nomeFiltro: "Nombre del filtro",
    salvo: "Filtro guardado",
    aplicado: "Filtro aplicado: {{nome}}",
    confirmarExcluir: '¿Eliminar el filtro "{{nome}}"?',
    predefinidos: "Filtros predefinidos",
    nenhum: "Ninguno",
    predef: {
      criadas_14: "Creadas en los últimos 14 días",
      criadas_90: "Creadas en los últimos 3 meses",
      sem_contato_14: "Sin contacto en los últimos 14 días",
      atrasadas: "Con tareas atrasadas",
      vendidas: "Vendidas",
      perdidas: "Perdidas",
      abertas: "Abiertas",
    },
    semTarefa: "Ver solo las negociaciones sin tarea",
    vazios: "Campos vacíos",
    campoVazio: {
      previsao: "Previsión de cierre",
      fonte: "Fuente",
      campanha: "Campaña",
      produtos: "Productos",
    },
    nome: "Nombre de la negociación",
    valorMin: "Valor total desde ({{simbolo}})",
    valorMax: "Valor total hasta ({{simbolo}})",
    qualquerData: "Cualquier fecha",
    presets: {
      hoje: "Hoy",
      "7": "Últimos 7 días",
      "14": "Últimos 14 días",
      "30": "Últimos 30 días",
      "90": "Últimos 3 meses",
      n7: "Próximos 7 días",
      n30: "Próximos 30 días",
    },
    datas: {
      criada: "Fecha de creación",
      contato: "Fecha del último contacto",
      proxima: "Fecha de la próxima tarea",
      fechada: "Fecha de cierre",
      previsao: "Previsión de cierre",
    },
    empresa: "Empresa",
    campanha: "Campaña",
    fonte: "Fuente",
    produto: "Producto o servicio",
    vertical: "Vertical",
    vazioEtiqueta: "Vacío: {{campo}}",
    valorEtiqueta: "Valor de {{de}} a {{ate}}",
  },
  contagem: {
    parcial:
      "{{feitos}} de {{total}} ya se hicieron; el resto se detuvo con: {{erro}}. Las que faltan siguen seleccionadas.",
    ajuda:
      "Para confirmar, completa con la cantidad de elementos que se cambiarán.",
    placeholder: "Cantidad de elementos",
    ciente: "Entiendo que esta acción no se puede deshacer.",
  },
  ficha: {
    voltar: "Volver",
    carregando: "Cargando la negociación",
    abasRotulo: "Secciones de la negociación",
    etapas: "Etapas del embudo",
    abas: {
      historico: "Historial",
      email: "Correo",
      tarefas: "Tareas",
      questionarios: "Cuestionarios",
      produtos: "Productos",
      arquivos: "Archivos",
      propostas: "Propuestas",
    },
    adicionar: "Agregar",
    adicionarContato: "Agregar contacto",
    ata_one: "Acta y {{count}} archivo",
    ata_other: "Acta y {{count}} archivos",
    campos: {
      nome: "Nombre",
      previsao: "Previsión de cierre",
      fechamento: "Fecha de cierre",
      criada: "Creada el",
      valor: "Valor total",
      ultimoContato: "Último contacto",
    },
    concluirTarefa: "Completar la tarea {{titulo}}",
    contatoExistente: "Contacto del registro",
    copiado: "Copiado",
    copiar: "Copiar",
    dias_one: "{{count}} día",
    dias_other: "{{count}} días",
    duplicada: "Negociación duplicada",
    duplicar: "Duplicar negociación",
    editarCampo: "Editar {{campo}}",
    excluida: "Negociación eliminada",
    excluir: "Eliminar negociación",
    excluirTexto:
      'La negociación "{{titulo}}" y sus tareas van a la papelera por 30 días.',
    excluirTitulo: "¿Eliminar negociación?",
    filtroTarefas: "Tareas",
    marcarPerda: "Marcar pérdida",
    marcarVenda: "Marcar venta",
    pausar: "Pausar negociación",
    retomar: "Reanudar negociación",
    playbook: "Abrir playbook",
    principal: "Principal",
    proximaAcao: "Próxima acción recomendada",
    proximasTarefas: "Próximas tareas",
    excluirTarefa: "Eliminar la tarea {{titulo}}",
    reabrirTarefa: "Reabrir la tarea {{titulo}}",
    maisOpcoesTarefa: "Más opciones de {{titulo}}",
    cancelarReuniao: "Cancelar reunión",
    confirmarCancelarReuniao: "¿Cancelar esta reunión?",
    confirmarCancelarReuniaoTexto: "La reunión {{titulo}} queda cancelada aquí y también en la Agenda, si se agendó por ella.",
    reuniaoCancelada: "Reunión cancelada",
    recomendaAgendar:
      "Agenda un próximo paso con el cliente para no perder el ritmo de la negociación.",
    recomendaConcluir:
      'Completar la tarea "{{titulo}}", agendada para {{data}}.',
    removerContato: "Quitar a {{nome}} de la negociación",
    // Lista de 03/11, item 3: empresas adicionais na ficha da negociação.
    empresasAdicionais: "Otras empresas",
    semEmpresasAdicionais: "Ninguna otra empresa en la negociación.",
    adicionarEmpresa: "Agregar otra empresa",
    removerEmpresa: "Quitar a {{nome}} de la negociación",
    secoes: {
      negociacao: "Negociación",
      contatos: "Contactos",
      empresa: "Empresa",
      responsavel: "Responsable",
    },
    semCampanha: "Sin campaña",
    semContato: "Aún sin contacto",
    semContatos: "Ninguna persona de contacto en la negociación.",
    semPendentes: "No hay tareas pendientes en esta negociación.",
    reuniaoAgenda: { diaInteiro: "Todo el día", titulo: "Reunión de la Agenda", abrir: "Abrir en la Agenda", semAssunto: "Reunión sin asunto", estado: { marcado: "Agendada", confirmado: "Confirmada", realizado: "Realizada", faltou: "No ocurrió", cancelado: "Cancelada" } },
    tarefas: {
      pendentes: "Tareas pendientes",
      concluidas: "Tareas completadas",
      todas: "Todas las tareas",
      vazio: "Ninguna tarea en este filtro.",
    },
    tornarPrincipal: "Hacer de {{nome}} el contacto principal",
    whatsapp: "Abrir en WhatsApp",
    produtos: {
      adicionar: "Agregar producto o servicio",
      editarTitulo: "Editar producto o servicio",
      vazio: "No hay ningún producto o servicio en esta negociación.",
      acoes: "Acciones",
      colunas: {
        nome: "Nombre y recurrencia",
        quantidade: "Cantidad",
        preco: "Precio y descuento",
        subtotal: "Subtotal",
      },
      descontoPct: "Descuento: {{pct}}% ({{valor}})",
      descontoValor: "Descuento: {{valor}}",
      editar: "Editar {{nome}}",
      remover: "Quitar {{nome}}",
      confirmarRemover: "¿Quitar el producto de la negociación?",
      unico: "Valor único",
      recorrente: "Valor recurrente",
      total: "Valor total",
      adicionado: "Producto agregado",
      adicionadoOutro: "Producto agregado. Elige el siguiente.",
      criarEOutro: "Crear y agregar otro",
      verticalDoProduto: "Vertical del producto",
      verticalTodas: "Todas",
      atualizado: "Producto actualizado",
      passo1: "1. Elegir producto",
      passo2: "2. Configurar producto",
      catalogo: "Producto o servicio del catálogo",
      avancar: "Avanzar",
      voltar: "Volver",
      adicionarBotao: "Agregar producto",
      precoBase: "Precio base: {{valor}}",
      valor: "Valor unitario",
      acrescentarDesconto: "Agregar descuento",
      escolhaVertical: "Elige la vertical",
      escolhaVerticalPrimeiro: "Elige la vertical para ver los servicios que ofrece.",
      verticalNova: "{{nome}} (nueva en la negociación)",
      verticalNovaAjuda: "Esta vertical aún no es de la negociación; al guardar el ítem, pasa a valer también en la negociación.",
      servicoForaDaVertical: "El servicio \"{{nome}}\" no se ofrece en esta vertical. Elige el servicio de nuevo.",
      tipoDesconto: "Tipo de descuento",
      tipos: {
        percentual: "% Porcentaje",
        valor: "{{simbolo}} Valor",
      },
      valorDesconto: "Valor del descuento ({{unidade}})",
      equivalePct: "{{pct}}% = {{valor}} de descuento",
      equivaleValor: "{{valor}} = {{pct}}% del valor",
      limites: {
        negativo: "El descuento no puede ser negativo",
        percentualMaximo: "En porcentaje, como máximo 100%",
        valorMaximo: "En valor, como máximo {{maximo}} (valor x cantidad)",
      },
      resumoBruto: "Valor unitario x cantidad",
      resumoDesconto: "Descuento",
      resumoLiquido: "Valor del producto en la negociación",
      escolha: "Elige un producto del catálogo",
      quantidadeInvalida: "Indica una cantidad mayor que cero",
    },
  },
  proposta: {
    criar: "Crear propuesta",
    nova: "Nueva propuesta",
    vazio:
      "Crea y envía propuestas al cliente con los productos de esta negociación.",
    semItens: "Agrega un producto a la negociación para crear la propuesta.",
    numero: "Propuesta #{{numero}}",
    lista: {
      proposta: "Propuesta",
      modelo: "Modelo",
      criada: "Creada el",
      valor: "Valor",
      status: "Estado",
    },
    estados: {
      criada: "Creada",
      enviada: "Enviada",
      aceita: "Aceptada",
      recusada: "Rechazada",
    },
    enviarEmail: "Enviar por correo",
    imprimir: "Imprimir",
    imprimirDeNovo: "Abrir el PDF de nuevo",
    mudarStatus: "Cambiar el estado de la propuesta #{{numero}}",
    excluir: "Eliminar la propuesta #{{numero}}",
    acoes: "Acciones",
    excluirTitulo: "¿Eliminar la propuesta #{{numero}}?",
    excluirTexto:
      "La propuesta sale de la negociación y puedes recuperarla desde la Papelera durante 30 días. El PDF ya enviado sigue en Archivos.",
    excluida: "Propuesta eliminada",
    impressaAberta:
      "El PDF de la propuesta (el mismo que va en el correo) se abrió en otra pestaña: imprímelo o guárdalo allí. Si la pestaña no se abrió, usa el botón de abajo.",
    criarImprimir: "Crear e imprimir",
    criarEmail: "Crear y enviar por correo",
    criada: "Propuesta creada",
    modelo: "Modelo",
    modeloPadrao: "{{nome}} (estándar)",
    previa: "Vista previa",
    campos: {
      titulo: "Título",
      apresentacao: "Presentación",
      condicoes: "Condiciones generales",
      rodape: "Pie",
    },
    colunas: {
      produto: "Producto o servicio",
      quantidade: "Cant.",
      desconto: "Descuento",
      preco: "Precio",
      subtotal: "Subtotal",
    },
    semTitulo: "Propuesta comercial",
    aosCuidados: "A/A: {{contato}} | {{cliente}}",
    totalPedido: "Valor total del pedido",
    itensTabela: "Ítems de la propuesta",
    condicoes: "Condiciones generales",
  },
  email: {
    criar: "Crear correo",
    enviar: "Enviar correo",
    enviado: "Correo enviado",
    vazio: "Ningún correo enviado por esta negociación.",
    para: "Para",
    paraAjuda:
      "Solo el correo del cliente o de una persona de contacto de la negociación.",
    paraQuem: "Para: {{para}}",
    assunto: "Asunto",
    texto: "Mensaje",
    semAcessoCadastros:
      "Los correos del cliente y de los contactos están en Registros, y no tienes acceso. Pídelo a quien administra los accesos.",
    semDestino:
      "El cliente y las personas de contacto no tienen correo en el registro.",
    comProposta:
      "Propuesta #{{numero}} en PDF ({{total}})",
    assuntoProposta: "Propuesta comercial #{{numero}} · {{titulo}}",
    ola: "¡Hola, {{nome}}!",
    olaSemNome: "¡Hola!",
    textoProposta:
      "{{saudacao}}\n\nAdjunto la propuesta comercial. Quedo a disposición para cualquier duda.\n\nSaludos,\n{{autor}}",
    // Lote crm4 (L8): anexos do "Criar e-mail" (arquivos da negociação).
    anexar: "Adjuntar archivo",
    anexos: "Adjuntos",
    anexosAjuda: "Hasta {{max}} archivos, {{limite}} en total ({{porArquivo}} por archivo): imagen, PDF, Word, Excel, PowerPoint, OpenDocument, TXT o CSV. Los archivos quedan también en la pestaña Archivos de la negociación.",
    anexosAjudaProposta: "La propuesta va en PDF y cuenta en el límite: {{max}} archivos más, hasta {{limite}} sumados, más su PDF ({{porArquivo}} por archivo). Los archivos quedan también en la pestaña Archivos de la negociación.",
    removerAnexo: "Quitar {{nome}}",
    anexoGrande: "{{nome}} supera el límite: los adjuntos suman hasta {{limite}}.",
    anexoArquivoGrande: "{{nome}} supera el límite de {{limite}} por archivo.",
    anexoTipo: "{{nome}} no puede ir en el correo: envía imagen, PDF, Word, Excel, PowerPoint, OpenDocument, TXT o CSV.",
    anexosDemais: "Adjunta hasta {{max}} archivos.",
    enviandoAnexos: "Subiendo los adjuntos",
  },
  questionarios: {
    vazio:
      "Ningún cuestionario. Créalos en Configuración del CRM > Cuestionarios.",
    escolher: "Cuestionario",
    respondido: "{{nome}} (respondido)",
    salvar: "Guardar respuestas",
    salvo: "Respuestas guardadas",
    concluir: "Concluir",
    salvarRascunho: "Guardar borrador",
    rascunhoSalvo: "Borrador guardado",
    alteradoPor: "Último cambio de {{nome}} el {{quando}}",
    excluirAplicacao: "Eliminar este cuestionario",
    confirmarExcluirAplicacao: "¿Eliminar este cuestionario de la negociación?",
    confirmarExcluirAplicacaoTexto: "Sus respuestas dejan de mostrarse. Los demás cuestionarios no cambian.",
    excluido: "Cuestionario eliminado",
    novo: "Nuevo cuestionario",
    nenhum: "Aún no hay cuestionarios en esta negociación. Elige una plantilla y pulsa Nuevo cuestionario.",
    escolherModelo: "Plantilla del cuestionario",
    iniciar: "Iniciar",
    iniciado: "Cuestionario iniciado",
    semModelos: "Ninguna plantilla activa. Crea una en Configuración del CRM > Cuestionarios.",
    lista: "Cuestionarios de la negociación",
    emAndamento: "En curso",
    concluido: "Concluido",
    abrir: "Abrir {{nome}}",
    recolher: "Contraer {{nome}}",
    numero: "{{nome}} · n.º {{n}}",
    iniciadoEm: "Iniciado el {{quando}}",
    concluidoEm: "Concluido el {{quando}}",
    pontosResumo: "{{count}} pt",
    resumoTotal_one: "{{count}} cuestionario",
    resumoTotal_other: "{{count}} cuestionarios",
    sim: "Sí",
    nao: "No",
  },
  arquivos: {
    soltar: "Arrastra y suelta el archivo aquí o haz clic para elegir",
    vazio: "Ningún archivo en esta negociación.",
    enviados: "Archivos enviados",
    baixar: "Descargar {{nome}}",
    excluir: "Eliminar {{nome}}",
    confirmarExcluir: "¿Eliminar el archivo?",
  },
  pausa: {
    tituloPausar: "Pausar negociación",
    tituloRetomar: "Reanudar negociación",
    textoPausar: "Cuéntanos por qué se pausa esta negociación. Mientras esté pausada, no se puede cambiar nada en ella. El motivo queda en el historial.",
    textoRetomar: "Cuéntanos por qué esta negociación vuelve a avanzar. El motivo queda en el historial.",
    motivo: "Motivo",
    erroMotivo: "Indica el motivo, de {{min}} a {{max}} caracteres.",
    confirmarPausar: "Pausar",
    confirmarRetomar: "Reanudar",
    aviso: "Negociación pausada: reanúdala para poder cambiarla.",
    naoMove: "Negociación pausada: reanúdala antes de moverla de etapa.",
    naoEncerra: "Negociación pausada: reanúdala antes de marcar una venta o una pérdida.",
  },
  playbook: {
    titulo: "Orientaciones por etapa",
    ajuda:
      "Qué hacer en cada etapa del embudo, y los ítems para revisar en esta negociación.",
    objetivo: "Objetivo de la etapa",
    descricao: "Descripción",
    semObjetivo: "El objetivo de la etapa aún no fue configurado.",
    semDescricao: "La descripción aún no fue configurada.",
    configurar: "Configurar el playbook",
  },
};
